(function() {
  "use strict";

  angular.module("sempraWebapp").constant("ruTranslations", {
      MESSAGE:"Сообщение",
      ERROR_TITLE:"Ошибка",
      ERROR_MESSAGE:"Возникла ошибка при выполнении операции.",
      ERROR_LOGIN:"При входе в систему произошла ошибка. Адрес недействительна",
      ERROR_LOGIN_ROLE:"Роль для текущего бренда приложения недействительна",
      OK:"ОК",
      CANCEL:"Отменить",
      YES:"Да",
      NO:"Нет",
      FROM:"От",
      TO:"К",
      DELETE:"Удалить",
      SIGN_OUT:"Выйти из аккаунта",
      NAME:"Имя",
      DATE:"Дата",
      PIECES:"Части",
      HOURS:"Часы",
      DAYS:"Дни",
      MONTH:"Месяц",
      MONTHS:"Месяца",
      YEAR:"Год",
      BOX:"Бокс",
      SEARCH:"Поиск",
      ALL_USERS:"Все пользователи",
      ARE_YOU_SURE:"Вы уверены?",
      BACK:"Назад",
      AMOUNT:"Сумма",
      DESCRIPTION:"Описание",
      FORGOT_PASSWORD_ERROR_MSG:"Что-то пошло не так. Пожалуйста, проверьте свой адрес электронной почты и повторите попытку",
      REQUIRED_FIELD:"Поле обязательное",
      LOGOUT_TITLE:"Вы уверены, что хотите выйти из системы?",
      LOGOUT_MSG:"Все несохраненные данные будут потеряны",
      ACTIVATION_ACCOUNT:"Вы успешно активировали свою учетную запись",
      UNKNOWN_ERRROR_NOTIFICATION:"Произошла неизвестная ошибка",
      CONTINUE:">> Далее",
      DATA_NOT_AVAILABLE:"Данные недоступны",
      SELECT:"Выбрать",
      SELECT_CURRENCY:"Выберите валюту",
      UPLOAD:"Скачать",
      PHONE:"Телефон",
      WEBSITE:"Сайт",
      WORKING_HOURS:"Время работы",
      INSERT:"Вставить",
      TEXT:"Текст",
      CREATED:"Создан",
      VALID_UNTIL:"Действителен до",
      SAVE:"Сохранить",
      TOKENS:"Жетоны",
      DELETE_COMPANY_HISTORY:"Удалить историю компании?",
      DELETE_COMPANY_HISTORY_INFO:"Это действие удалит все данные отчетов вашей компании. Это действие невозможно отменить.",
      DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Вы уверены, что хотите навсегда удалить все данные отчетов?",
      DELETE_COMPANY_HISTORY_MESSAGE:"ПРЕДУПРЕЖДЕНИЕ: После нажатия этой кнопки все транзакции вашей автомойки будут навсегда удалены! Эти данные невозможно восстановить.",
      DELETE_COMPANY_HISTORY_CONFIRMATION:"Вы уверены, что хотите навсегда удалить все данные о транзакциях?",
      HISTORY_SUCCESSFULY_DELETED:"История успешно удалена",
      HELP:"Помогите",
      VALUE:"Значение",
      ACTIVATING_ACCOUNT_ERROR:"Возникла проблема с активацией аккаунта R2W. Пожалуйста, попробуйте еще раз, и если проблема не исчезнет, ​​обратитесь к нашей поддержки на support@ready2wash.com.",
      ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Добро пожаловать в автомойку Kärcher",
      ACTIVATING_ACCOUNT_WELCOME_MSG:"Добро пожаловать в R2W",
      ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Пожалуйста, введите новый пароль и подтвердите его, чтобы активировать учетную запись R2W. После успешного завершения вам автоматически будет открыт вход",
      ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Вы позже можете изменить свои настройки пользователя в приложении",
      RESET_PASSWORD_WELCOME_KARCHER_MSG:"Автомойка Kärcher",
      RESET_PASSWORD_WELCOME_MSG:"Автомойка R2W",
      RESET_PASSWORD_WELCOME_MSG_2:"Введите новый пароль и подтвердите его, чтобы сбросить старый. После успешного выполнения вы будете автоматически авторизованы в приложении.",
      RESET_PASSWORD_WELCOME_MSG_3:"Вы сможете изменить свои пользовательские настройки позже в приложении.",
      ENTER_NEW_PASSWORD:"Введите пароль",
      REPEAT_NEW_PASSWORD:"Повторите новый пароль",
      PASSWORD_MIN_LENGTH:"Пароль должен состоять не менее 8 символов",
      PASSWORD_MAX_LENGHT:"Пароль должен быть не более 32 символов",
      PASSWORD_PATTERN:"Пароль должен содержать хотя бы одну заглавную букву и одну букву нижнего регистра",
      PASSWORD_MATCH:"Пароли не совпадают",
      ACTIVATE:"Активировать",
      SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Вы успешно отправили запрос. Пожалуйста, проверьте вашу электронную почту для подтверждения сообщения",
      VALIDATION_REQUIRED:"Обязательное поле",
      VALIDATION_EMAIL:"Неверный адрес электронной почты",
      VALIDATION_INTEGER_NUMBER:"Пожалуйста, введите целое значение",
      VALIDATION_HOURS_VALUE:"Значение должно быть от 0 до 23",
      VALIDATION_MINUTES_VALUE:"Значение должно быть от 0 до 59",
      VALIDATION_NOT_A_DATE:"Значения не является датой",
      VALIDATION_FROM:"От даты большей, чем в",
      VALIDATION_TO:"На сегодняшний день меньше, чем",
      ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Эта запись уже существует в базе данных",
      PASSWORD_VALIDATION_PATTERN_NEW:"Там должна быть по крайней мере одна цифра и одна большая буквы. Пробелы не допускаются",
      VALIDATION_PERCENT_VALUE:"Значение должно быть между 1-999",
      NUMBERS_ONLY_100:"Количество до 100",
      NUMBERS_ONLY_1000:"Число до 1000",
      POSITIVE_NUMBERS_ONLY:"Только положительное число",
      GRID_PAGER_PAGE:"Страница",
      GRID_PAGER_ROWS_PER_PAGE:"Строки на страницу",
      GRID_PAGER_PAGE_OF:"От",
      BREAD_CRUMBS_HOME:"Главная",
      BREAD_CRUMBS_DASHBOARD_TECH:"Технология панели управления",
      BREAD_CRUMBS_DETAILS:"Подробности",
      BREAD_CRUMBS_SETTINGS:"Настройка",
      BREAD_CRUMBS_WORKING_HOURS:"Часы работы",
      BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Общая сумма денег по дням",
      BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Средняя денежная информация в час",
      BREAD_CRUMBS_NEW_USER_GROUP:"Создать группу пользователей",
      BREAD_CRUMBS_EDIT_USER_GROUP:"Редактировать группу пользователей",
      BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Создать шаблон кампании",
      BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Редактировать шаблон кампании",
      BREAD_CRUMBS_NEW_CAMPAIGN:"Создать кампанию",
      BREAD_CRUMBS_EDIT_CAMPAIGN:"Редактировать кампанию",
      BREAD_CRUMBS_PERIODIC_SUMMARY:"Периодический результат",
      LOGIN:"Войти",
      EMAIL:"Электронная почта",
      PASSWORD:"Пароль",
      LANGUAGE:"Язык",
      FORGOT_PASSWORD:"Забыли пароль?",
      SUBMIT:"Отправить",
      HEADER_NUMBER_OF_PENDING_ALARMS:"Количество ожидаемых сигналов:",
      HEADER_VIEW_ALL_ALARMS:"Посмотреть все уведомления ...",
      HEADER_MY_ACCOUNT:"Мой счет",
      HEADER_ACCOUNT_MANAGEMENT:"Управление счетами",
      ACCOUNT_ALREADY_EXIST:"Адрес электронной почты уже используется",
      NEWSLETTER_CONFIRMATION:"Отправить уведомление по электронной почте для состояния тревоги",
      ASIDE_MENU_DASHBOARD_FINANCIAL:"Obzor yezhednevnykh finansov",
      ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Технология панели управления",
      ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Приборная доска",
      ASIDE_MENU_ALARMS:"Сообщение",
      ASIDE_MENU_FACILITIES:"Объекты",
      ASIDE_MENU_REPORTS:"Отчеты",
      ASIDE_MENU_REPORT:"Выбранный отчёт",
      ASIDE_MENU_LOYALTY:"Лояльность",
      ASIDE_MENU_USER_GROUPS:"Группы пользователей",
      ASIDE_MENU_PERIODIC_SUMMARY:"Периодический результат",
      ASIDE_MENU_MANAGING_TOKENS:"Управление токенами",
      ASIDE_MENU_NEWS:"Новости",
      DAILY_FINANCES_TOTAL_MONEY:"Всего денег",
      DAILY_FINANCES_TOTAL_MONEY_ALL:"Сумма денег на всех объектах",
      DAILY_FINANCES_TOTAL_COINS:"Всего жетонов",
      DAILY_FINANCES_DOWNLOAD_CSV:"Скачать CSV",
      DAILY_FINANCES_ONLINE:"R2W (онлайн)",
      DAILY_FINANCES_OFFLINE:"Монеты",
      DAILY_FINANCES_CHANGER:"Чейнджер",
      DAILY_FINANCES_COINS:"Токены / Eurokey",
      REPORTS_FILTER:"Фильтровать",
      REPORTS_TYPE_OF_REPORT:"Тип отчета",
      REPORTS_CHOOSE_FACILITY:"Выберите объект",
      REPORTS_PERIOD_1:"Период 1 -",
      REPORTS_PERIOD_2:"Период 2 -",
      MONEY_BY_DATE_REPORT:"Совокупный доход по дате",
      R2W_BY_DATE_REPORT:"Общее количество потраченных жетонов R2W по дате",
      COINS_BY_DATE_REPORT:"Всего монет по дате",
      AVG_MONEY_BY_HOUR_REPORT:"Средний доход в час",
      AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Средний доход за днем ​​недели",
      AVG_MONEY_BY_BOX_REPORT:"Расходы на мойку",
      COMPARE_PERIODS_REPORT:"Сравнительный отчет по объекту",
      TOTAL_USERS_BY_GROUP:"Всего пользователей программы R2W за день",
      TOTAL_USERS_BY_GROUP_USERS_UNIT:"пользователей",
      TOTAL_USERS_BY_GROUP_VISITS_UNIT:"посещения",
      VISITS_COUNT_REPORT:"Количество пользователей приложения R2W за каждое посещение",
      LOYALTY_PER_DAY_REPORT:"Количество локальных жетонов, потраченных за день",
      LOYALTY_PER_PAYMENT_METHOD:"Учитывая локальные жетоны за каждым способом оплаты",
      VISITS:"посещение",
      VISIT:"визиты",
      TOTAL_SPENT_MONEY:"Общий доход",
      MONEY:"Деньги",
      TOTAL_SPENT_MONEY_FOR_PERIOD:"Общее количество потраченных денег за период",
      DOWNLOAD_CSV:"Скачать CSV",
      TOTAL_SPENT_COINS:"Всего потрачено жетонов",
      TOTAL_USERS:"Всего пользователей",
      TOTAL_CREDIT_GIVEN:"Всего потрачено локальных виртуальных жетонов",
      EUROKEY_BY_DATE_REPORT:"Общая сумма платежей Eurokey по дате",
      TOTAL_SPENT_EUROKEY:"Всего потрачено",
      SELECT_TYPE_OF_REPORT:"Вам нужно выбрать тип отчета :)",
      NUMBER_OF_VISITS_TITLE:"Количество посещений",
      NUMBER_OF_USERS_TITLE:"Количество пользователей",
      PIECES_TITLE:"Куски",
      TOTAL_VISITS:"Всего посещений",
      TOKENS_TITLE:"жетоны",
      SEARCH_USERS_NO_RESULTS:"Не найдено ни одного пользователя по данному поисковым термином",
      SEARCH_USERS:"Поиск пользователей",
      SEARCH_TELEPHONES:"Поиск пользователей по мобильным номером",
      ADD_USER_TO_GROUP:"Добавить пользователя в группу",
      REMOVE_USER_FROM_GROUP:"Удалить пользователя из группы",
      USER_GROUP_NAME_REQUIRED:"Имя группы пользователей обязательное",
      USER_GROUP_NAME:"Название группы пользователей",
      USER_GROUPS_OVERVIEW:"Обзор групп пользователей",
      USER_COUNT:"количество пользователей",
      NEW_USER_GROUP:"Создать новую группу пользователей",
      DELETE_USER_GROUP:"Удалить группу пользователей",
      UPDATE_USER_GROUP:"Редактировать группу пользователей",
      DELETE_USER_GROUP_ERROR:"При удалении выбранной группы пользователей возникла ошибка. Пожалуйста, повторите попытку или свяжитесь со службой поддержки",
      CONFIRM_DELETE_USER_GROUP:"Вы уверены, что хотите удалить выбранную группу пользователей?",
      CONFIRM_DELETE_USER_GROUP_TEXT:"Действия лояльности, на которые возложена удалена группа, больше применяться не будут.",
      GROUP_NAME_MAX_LENGTH:"Название группы должен содержать не более 255 символов",
      USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Пользователь уже находится в этой группе",
      MISSING_USER:"Отсутствует пользователь",
      USER_NOT_ON_LIST:"Пользователь не находится в списке активных пользователей. Проверьте правильность адреса электронной почты и повторите попытку.",
      UPLOAD_USER_GROUP:"Загрузите список групп пользователей из файла * .csv",
      UKNOWN_USERS:"Список неизвестных пользователей",
      CAMPAIGN_TEMPLATE_RULE:"Правило шаблона",
      DELETE_CAMPAIGN_TEMPLATE_ERROR:"При попытке удалить шаблон кампании произошла ошибка. Пожалуйста, повторите попытку или свяжитесь со службой поддержки",
      CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Вы уверены, что хотите удалить выбранный шаблон кампании",
      CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Вы уверены, что хотите удалить выбранный шаблон кампании",
      CAMPAIGN_TEMPLATES_OVERVIEW:"Обзор шаблонов кампании",
      DELETE_CAMPAIGN_TEMPLATE:"Удалить шаблон кампании",
      UPDATE_CAMPAIGN_TEMPLATE:"Редактировать шаблон кампании",
      CREATE_CAMPAIGN_TEMPLATE:"Создайте новый шаблон кампании",
      CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Имя шаблона кампании обязательное",
      CAMPAIGN_TEMPLATE_NAME:"Название шаблона кампании",
      CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Обязательное поле",
      CAMPAIGN_TEMPLATE_RULE_GIVE:"Дать",
      CAMPAIGN_TEMPLATE_RULE_CREDITS:"Кредиты",
      CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:" Пожалуйста, сначала выберите тип. Мойка ящиков или небольших машин.",
      CAMPAIGN_TEMPLATE_REMOVE_RULE:"Удалить правило шаблона",
      CAMPAIGN_TEMPLATE_RULE_FROM:"от",
      CAMPAIGN_TEMPLATE_RULE_TO:"к",
      CAMPAIGN_TEMPLATE_RULE_HOURS:"Часов",
      CAMPAIGN_TEMPLATE_RULE_MINUTES:"Минут",
      CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Новое правило по количеству визитов",
      CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Новое правило по количеству потраченных денег",
      CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Новое правило по дням недели",
      CAMPAIGN_TEMPLATE_ADD_RULE:"Добавьте новое правило шаблона",
      CAMPAIGN_TEMPLATE_RULE_1:"Каждый",
      CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Каждый",
      CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"Кредиты, потраченные менее чем на",
      CAMPAIGN_TEMPLATE_RULE_2_VISITS:"Посещений меньше чем",
      CAMPAIGN_TEMPLATE_RULE_3:"Дни",
      CAMPAIGN_TEMPLATE_RULE_4:"Кредиты",
      CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Список правил пуст.",
      CAMPAIGN_FROM_DATE_TOO_EARLY:"Дата не может быть в прошлом",
      DELETE_CAMPAIGN_ERROR:"При попытке удалить кампанию произошла ошибка. Пожалуйста, повторите попытку или свяжитесь со службой поддержки",
      CONFIRM_DELETE_CAMPAIGN:"Вы уверены, что хотите удалить выбранную кампанию?",
      CONFIRM_DELETE_CAMPAIGN_TEXT:"Вы уверены, что хотите удалить выделенный текст кампании?",
      CAMPAIGNS_OVERVIEW:"обзор кампаний",
      DELETE_CAMPAIGN:"Удалить кампанию",
      UPDATE_CAMPAIGN:"Редактировать кампанию",
      CREATE_CAMPAIGN:"Создать новую кампанию",
      CAMPAIGN_ACTIVE:"Активный",
      CAMPAIGN_TEMPLATE:"Шаблон",
      CAMPAIGN_GROUPS:"Группы",
      CAMPAIGN_ALL_USERS:"Все пользователи",
      CAMPAIGN_NAME:"Название кампании",
      CAMPAIGN_NAME_REQUIRED:"Обязательно",
      CAMPAIGN_USERS_NEAR_TRESHOLD:"Количество пользователей накануне",
      MESSAGE_TO_USERS:"Сообщение для отфильтрованных пользователей",
      SEND_MESSAGE:"Отправить сообщение",
      THRESHOLD:"Предидущие",
      TYPE:"Тип",
      TOTAL_MONEY_SPENT:"Общие потраченные деньги в кампании",
      NUMBER_OF_VISITS:"Количество посещений в кампании",
      SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Сообщение должно содержать не менее 10 символов",
      SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Сообщение должно быть не более 350 символов",
      SEND_MESSAGE_REQUIRED_VALIDATION:"Текст сообщения обязательный",
      TECHNOLOGY:"Технология",
      TAP_WATER:"Вода входная",
      REVERSE_OSMOSIS:"Обратный осмос",
      SOFTENED_WATER:"Смягченная вода",
      DOSER:"Дозатор",
      STATUS:"Состояние дел",
      LAST_SYNCHRONIZATION:"Последняя синхронизация",
      NO_OF_CURRENT_ALARMS:"Количество текущих сигналов тревоги",
      NO_OF_CURRENT_WARNINGS:"Количество текущих предупреждений",
      WEATHER:"Погода",
      BOXES_WORK_HOURS_COUNTERS:"Часы рабочего времени",
      BOX_TOTAL_HOURS:"Общее время работы",
      BOX_SERVICE_HOURS:"Общее время работы (сервис)",
      BOX_COUNTER_HOURS:"Часов",
      ALARMS_AND_WARNINGS:"Предупреждения",
      FILTER_AND_BOILER:"Фильтр и котел",
      FILTER_TOTAL_DAYS:"Фильтр рабочие дни",
      BOILER_TOTAL_DAYS:"Рабочие дни котла",
      DAYS_UNIT:"Дни",
      SOFTENER:"Умягчения",
      MANUAL_COLD_DRAIN:"Ручной холодный сток",
      EL_COLD:"Эл. холодный",
      DRAIN:"Сток",
      TAP:"Коснитесь",
      WASTE:"Отходы",
      OSMOSIS:"Осмос",
      DEMI_WATER:"Деминирализована вода",
      EL_RINSE:"Эл м. Полоскания",
      BOILER:"Бойлер/Котел",
      EL_WAX:"Эл м. Воск",
      FLOOR_HEATING:"Подогрев пола",
      DOSER_TANK:"Дозатор бак",
      EL_WASH:"Эл м. Мытья",
      DETERGENT:"Микро-порошок",
      VIBRATOR:"Вибратор",
      UPDATE_FACILITY_SETTINGS:"Обновить настройки",
      GENERAL_SETTINGS:"Общие настройки",
      LIGHTS:"Свет",
      GROUPS:"Группы",
      ANTI_FREEZE:"Антизамерзание",
      AUTO:"Автоматически",
      MANUAL:"Вручную",
      ON:"Включить",
      OFF:"Отключить",
      TEMPERATURE:"Температура",
      UPDATE_DEVICE:"Обновления настроек объекта",
      BOX_CLEAN_HOURS:"Бокс чистый счетчик (часы)",
      GROUP_COUNTERS:"Групповые счетчики",
      RESET:"Сбросить",
      CASH_COUNT:"Количество монет",
      COINS_COUNT:"Количество жетонов",
      EUROKEY_COUNT:"Количество Еurokey",
      DOSER_WORK:"Рабочее время дозатора (сек.)",
      DOSER_PAUSE:"Время паузы дозатора (сек.)",
      DELAY_BFV:"Задержка BFV (мс)",
      DELAY_6M1:"Задержка 6M1 (мс)",
      DELAY_LPS:"Задержка LPS (мс)",
      RESET_CASH_COUNT_ALL:"Сбросить все счетчики монет",
      RESET_COINS_COUNT_ALL:"Сбросить все счетчики жетонов",
      RESET_EUROKEY_COUNT_ALL:"Сбросить все счетчики Еurokey",
      FACILITY_DETAILS:"Детали объекта",
      FACILITY_NAME:"Название объекта",
      FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Вы успешно загрузили изображение",
      FACILITY_UPDATE_DATA_NOTIFICATION:"Вы успешно обновили данные",
      CONNECTED:"связанный",
      DISCONNECTED:"Отключено",
      OFFLINE:"отсоединены",
      MESSAGES_FILTER:"фильтровать сообщения",
      FACILITY:"Объект",
      APPLY:"Применить",
      TIME:"Время",
      LOCATION:"Местонахождение",
      ACKNOWLEDGED:"Признано",
      FILTERED_MESSAGES:"Отфильтрованные сообщения",
      ACK:"Признано",
      NOT_ACK:"Не признана",
      ALL:"Все",
      ALL_FACILITIES:"все объекты",
      ENTER_DATE_PLACEHOLDER:"Введите дату",
      OP_NESTANAK_NAPONA:"Отсутствует напряжение на фазовом индикаторе 3А5",
      OP_OTB_PUMPA_GRESKA_MZS:"Автоматический выключатель высокого давления сброшено",
      OP_UPR_NAPON_24VAC_GRE:"Отсутствует 24 VAC - автоматический выключатель 5F1.1",
      OP_MIN_NIVO_PITKA_VODA:"Бак для пресной воды пустой",
      OP_CRPKA_PITKE_VODE_GRE_MZS:"Автоматический выключатель сетевого насоса сброшено",
      OP_MIN_NIVO_OMEKS_VODE:"Бак для смягчения воды пустой",
      OP_CRPKA_OMEKS_VODE_GRE_MZS:"Насос циркуляции смягчения воды сброшено",
      OP_MIN_NIVO_DEMIN_VODE:"Бак осмосированной воды пустой",
      OP_CRPKA_DEMIN_VODE_GRE_MZS:"Насос циркуляции осмасированной воды сброшено",
      OP_CRPKA_REV_OSMOZA_GRE_MZS:"Автоматический выключатель насоса производства осмоса сброшено",
      OP_BOJLER_GRESKA_MZS:"Ошибка водонагревателя",
      OP_CRPKA_PRASKA_GRE_MZS:"Автоматический выключатель горячего водоснабжения сброшено",
      OP_DOZATOR_PRASKA_GRE_MZS:"Автоматический выключатель порошкового дозатора сброшено",
      OP_VIBRATOR_PRASKA_GRE_MZS:"Выключатель порошкового дозирования вибратора сброшено",
      OP_MIN_PRASAK_TON_ALARM:"Бак для смешивания микропорошка пустой",
      OP_USIS_KOV_TURBINA_GRESKA:"Автоматический выключатель вакуумной турбина всасывания моонет / жетонов сброшено",
      OP_FILTER_VODE_ZACEPLJEN:"Фильтр воды заблокировано",
      OP_VISKTL_RESET_SATI_RADA:"Сервис насоса высокого давления",
      OPW_VISKTL_RESET_SATI_RADA:"Сервис насоса высокого давления",
      OP_FILTER_DANI_RADA:"Ошибка фильтра воды",
      OP_BOJLER_DANI_RADA:"Ошибка водонагревателя",
      OPW_ALARM_VISOKOTL_PUMPA:"Сигнализация насоса высокого давления",
      OPW_ALARM_FILTER_SERVIS:"Сигнал необходимого сервиса фильтра",
      OPW_ALARM_BOJLER_SERVIS:"Сигнал необходимого сервиса бойлера",
      HAS_MEMBERS:"Выбранная группа имеет участников и не может быть удалена. Члены должны быть удалены в первую очередь.",
      PERIODIC_SUMMARY_FOR:"Периодический отчет ПО",
      PERIODIC_SUMMARY_REPORTS:"Периодические итоговые отчеты",
      DATE_RANGE:"Промежуток времени",
      FINANCIAL_REPORT:"Финансовый отчет",
      GROSS_INCOME:"Валовый доход",
      GROSS_INCOME_SUM:"Сумма валового дохода",
      COMMISSION_FEE:"Комиссионный сбор",
      NET_INCOME:"Чистая прибыль (для выставления счета)",
      COMMISSION_FEE_DETAILS:"Комиссионный сбор включая плату банка / PayPal или платеж поставщиков SMS-услуг.",
      LOYALTY_CREDITS_REPORT:"Отчеты по локальным жетонам",
      LOYALTY_GIVEN:"Учитывая локальные жетоны",
      LOYALTY_USED:"Используемые локальные жетоны",
      LOYALTY_SOLD:"Локальные жетоны загружены",
      LOYALTY_TOTAL:"Всего",
      LOYALTY_CURRENT_MONTH:"Текущий месяц",
      SOMETHING_WENT_WRONG:"Упс ....",
      MISSING_PAGE:"Извините, мы не смогли найти эту страницу",
      TRY_AGAIN:"Попробуйте еще раз",
      DEFAULT_ERROR_NAME:"Неизвестная ошибка",
      DEFAULT_ERROR_DESCRIPTION:"Пожалуйста попробуйте еще раз",
      MY_ACCOUNT_DETAILS:"Данные моего аккаунта",
      SAVE_CHANGES:"Сохранить изменения",
      USERNAME:"Имя пользователя",
      FIRST_NAME:"Имя",
      LAST_NAME:"Фамилия",
      USER_ROLE:"Роль пользователя",
      OLD_PASSWORD:"Старый пароль",
      NEW_PASSWORD:"Новый пароль",
      OLD_PASSWORD_REQUIRED:"Нужен старый пароль",
      NEW_PASSWORD_REQUIRED:"Новый пароль обязательный",
      NEW_PASSWORD_REPEAT:"Необходимо повторить новый пароль",
      NEW_PASSWORD_NOT_MATCH:"Старый и новый пароль не совпадают",
      PASSWORD_DIFFERENT_VALIDATION:"Новый пароль должен отличаться от старого",
      PASSWORD_MIN_CHAR:"Пароль должен состоять не менее 8 символов",
      PASSWORD_MAX_CHAR:"Ваш пароль должен содержать не более 32 символов",
      PASSWORD_PATTERN_VALIDATION:"Пароль должен содержать хотя бы одно число",
      ACCOUNT_MANAGEMENT:"Управление счетами",
      NOT_ACTIVE:"Не активный",
      ASSIGN_ROLE:"Назначить роль",
      UPDATE:"Обновить",
      ADD_NEW_ACCOUNT:"Добавить учетную запись",
      EMAIL_REQUIRED:"E-mail обязательно",
      EMAIL_NOT_VALID:"Адрес недействительна",
      ADD_NEW_USER_TEXT:"Электронное письмо с активационным ссылкой будет отправлен на указанный адрес электронной почты.",
      UPDATE_USER_NOTIFICATION:"Вы успешно обновили свою информацию",
      CHANGED_PASSWORD_NOTIFICATION:"Вы успешно изменили пароль",
      UPDATE_USER_GROUP_NOTIFICATION:"Вы успешно обновили название группы пользователей",
      CREATE_USER_GROUP_NOTIFICATION:"Вы успешно создали группу",
      DETELE_USER_GROUP_NOTIFICATION:"Вы успешно удалили группу",
      EMPTY_GROUP_LIST_MSG:"Не было создано групп. Начните с создания",
      DELETE_USER_FROM_GROUP_NOTIFICATION:"Вы успешно удалили пользователя из группы",
      ADD_USER_TO_GROUP_NOTIFICATION:"Вы успешно добавили пользователя в группу",
      ADD_USER_NOTIFICATION:"Вы успешно добавили нового пользователя",
      DELETE_USER_NOTIFICATION:"Вы успешно удалили пользователя",
      RESEND_USER_VERIFICATION_EMAIL:"Вы успешно повторно отправили письмо с подтверждением",
      ENTER_USER_GROUP_NAME_TO_CONTINUE:"Для создания группы пользователей",
      DELETE_USER:"Удалить пользователя",
      DELETE_USER_FROM_USER_GROUP_QUESTION:"Вы уверены, что хотите удалить пользователя из группы пользователей?",
      CAMPAIGN_DEFAULT_SMS_MESSAGE:"Уважаемый пользователь R2W",
      CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Норма лояльности по количеству визитов",
      CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Норма лояльности на потраченную сумму",
      CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Норма лояльности на каждый день недели",
      REMOVE_CAMPAIGN_RULE_TITLE:"Удаление правила кампании",
      REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Вы уверены, что хотите удалить правило кампании?",
      LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Вы успешно создали новую кампанию",
      LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Вы успешно активировали кампанию",
      LOYALTY_EMPTY_LIST_NOTIFICATION:"Не было создано кампаний. Начните с создания",
      LOYALTY_SENT_MESSAGE_NOTIFICATION:"Вы успешно прислали сообщение",
      COMPANY_ACCOUNTS:"Учетные записи компании",
      BUSSINESS_INVOICES_LIST:"Мои B2B счета-фактуры",
      LOCALE_TOKEN:"Локальный токен",
      R2W:"Глобальный токен",
      START_MONTH:"Начало месяца",
      END_MONTH:"Конечный месяц",
      TOKEN_TYPE:"Тип токена",
      TOKEN_NUMBER:"Номер маркера",
      NOTHING_TO_DISPLAY:"* Нечего продемонстрировать",
      CREATE_INVOICE:"Создать счета-фактуры",
      INVOICE:"Счет-фактура",
      INVOICES:"Счета-фактуры",
      EDIT_INVOICE:"Редактировать счет-фактуру",
      UPDATE_INVOICE_NOTIFICATION:"Вы успешно обновили счет-фактуру в ожидаемый статус",
      CURRENT_CHARGES:"Сборы за текущий период",
      PAYMENTS_ON_HOLD:"Счета в обработке",
      FOR_INVOICING:"Для счетов-фактур",
      CANCEL_INVOICING_NOTIFICATION_HEADER:"Вы собираетесь отменить счет-фактуру",
      CANCEL_INVOICING_NOTIFICATION_TEXT:"Вы уверены, что хотите отменить этот счет-фактуру?",
      INVOICING_NOTIFICATION_HEADER:"Вы собираетесь делать выставления счетов",
      INVOICING_NOTIFICATION_TEXT:"Вы уверены, что хотите прислать счет-фактуру?",
      SENT_INVOICE_NOTIFICATION:"Вы успешно прислали счет-фактуру",
      CANCELED_INVOICE_NOTIFICATION:"Вы успешно отменили счет-фактуру",
      INVOICE_DESCRIPTION_TEXT:"Счет для",
      INVOICE_STATE:"Состояние счета-фактуры",
      INVOICE_NUMBER:"Номер накладной",
      INVOICE_TOTAL:"Всего",
      SELECT_YEAR:"Выберите год",
      DOWNLOAD:"Скачать PDF",
      INVOICE_NUMBER_HEADER:"Вы пришлете счет-фактуру с номером",
      INVOICE_PAYMENT_CONFIRMATION:"Вы хотите подтвердить оплату",
      INSERT_INVOICE_NUMBER:"Введите номер счета-фактуры",
      INVOICED_WARNING:"Электронное письмо не было отправлено. Пожалуйста, подождите ...",
      SEND_INVOICE:"Отправить",
      INVOICE_ALL:"Все",
      INVOICE_FROM_R2W:"С R2W",
      INVOICE_TO_R2W:"К R2W",
      PAYMENT_REQUEST:"Запрос на оплату",
      PAYMENT_REQUEST_STATE:"Состояние запроса платежа",
      PAYMENT_REQUEST_NUMBER:"Номер платежного поручения",
      FOR_PAYMENT_REQUEST:"Запрос платежа",
      PAYMENT_REQUEST_ON_HOLD:"Запрос платежа в обработке",
      DOWNLOAD_INVOICE:"Скачать счет-фактуру",
      CLICK_FOR_DOWNLOAD_OPTIONS:"Нажмите, чтобы скачать параметры",
      B2B_SPEC:"B2B Спецификация",
      B2C_SPEC:"B2C Спецификация",
      DOWNLOAD_PAYMENT_REQUEST:"Запрос платежа",
      LOYALTY_PREVIEW:"Проверка лояльности",
      ACTIVATED:"Включен",
      RUNNING:"Ход",
      NOT_ACTIVATED:"Не активирован",
      FINISHED:"Готово",
      DEPRECATED:"Не суждено",
      UPCOMING:"Будущие",
      NONE:"Нет",
      STARTED:"Начало",
      ENDS:"Заканчивается",
      DEDICATED:"Посвященный",
      ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Вы активировать",
      CAMPAIGN:"Кампания",
      SEND_MESSAGE_NOTIFICATION:"Вы будете присылать сообщения выбранным группам пользователей",
      DIVISIBLE_TO_NUMBER:"Число должно делиться на ",
      BRIDGE_PLC:"Bridge - PLC",
      DEVICE_TYPE:"Тип устройства",
      LISTENER:"Маленькие машины",
      BRIDGE:"Мыть ящики",
      WASH_BOXES:"Мыть ящики",
      VACUUMS:"Пылесосы",
      SAVE_NEWS:"Сохранить новости",
      CREATE_NEW_NEWS:"Создать новые новости",
      HISTORY_OF_ALL_NEWS:"История всех новостей",
      TYPE_FACILITY_NAME_PLACEHOLDER:"Введите название объекта",
      ADD_ANOTHER_FACILITY_PLACEHOLDER:"Добавить еще один объект",
      NEWS_TEXT:"Текст новостей",
      NEWS_TITLE:"Название новостей",
      DELETE_NEWS_CONFIRMATION:"Вы собираетесь удалять новости",
      NEWS_DELETE_NOTIFICATION:"Вы успешно удаляете новости",
      NEWS_SAVE_NOTIFICATION:"Вы успешно сохранили новости",
      NEWS_CREATION_DATE:"Дата создания",
      NO_TITLE:"Нет заглавия",
      NEWS_TEXT_MAX_CHAR_VALIDATION:"Текст новостей должен содержать не более 255 символов",
      NEWS_TEXT_REQUIRED_VALIDATION:"Текст новостей обязательный",
      NEWS_TITLE_REQUIRED_VALIDATION:"Заголовок новости обязательный",
      DEACTIVATE:"Деактивировать",
      ASIDE_MENU_LOCAL_TOKENS:"Локальные жетоны",
      CREATE_NEW_LOCAL_TOKENS:"Выпуск новых локальных жетонов",
      ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Введите адрес электронной почты клиента и количество локальных жетонов, которые вы хотите выдать клиенту",
      CREATE_TOKENS:"Выпуск жетонов",
      MINIMUM_ONE_TOKEN:"Значение должно быть числом больше 0",
      CUSTOMER_EMAIL:"Электронная почта клиента",
      AMOUNT_OF_TOKENS:"Количество жетонов",
      ISSUING_LOCAL_TOKENS_SUCCESS:"Успешный выпуск локальных жетонов на",
      PROBLEM_ISSUING_LOCAL_TOKENS:"Возникла ошибка при выдаче локальных жетонов. Пожалуйста, проверьте адрес электронной почты клиента и повторите попытку.",
      HISTORY_OF_ISSUED_LOCAL_TOKENS:"Обзор выпущенных локальных жетонов",
      ISSUED_AT:"Выданный в",
      ISSUED_BY:"Выпущено в",
      CODE:"Активировать код",
      REDEEMED_BY:"Выкуплено",
      REDEEMED_AT:"Выкуплено в",
      ASIDE_MENU_VOUCHERS:"Ваучеры",
      PRINT:"Печать",
      VOUCHERS_OVERVIEW:"Обзор ваучеров",
      CREATE_NEW_VOUCHERS:"Создать новые ваучеры",
      CREATE_NEW_VOUCHERS_DESCRIPTION:"Создайте новую выкупную ваучерную партию, введите количество жетонов на ваучер",
      AMOUNT_OF_TOKENS_PER_VOUCHER:"Количество жетонов на ваучер",
      VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Вы можете назначить от 1 до 100 жетонов на ваучер",
      NUMBER_OF_NEW_VOUCHERS:"Количество ваучеров, которые нужно создать",
      VALIDATION_MIN_MAX_NEW_VOUCHERS:"Вы можете создавать от 1 до {{size}} ваучеров в одном пакете",
      NEW_VOUCHERS_PREFIX:"Новый ваучер серийный код префикса",
      VALIDATION_VOUCHER_PREFIX:"Префикс кода должен быть ровно 4 символа (заглавные буквы и / или цифры)",
      PROBLEM_CREATING_NEW_VOUCHERS:"Возникла проблема с созданием новых ваучеров. Пожалуйста, попробуйте еще раз или обратитесь к нашей поддержки.",
      CREATE_VOUCHERS:"Создать ваучеры",
      CREATING_VOUCHERS_SUCCESS:"Успешно созданы новые ваучеры",
      PRINT_NEW_VOUCHERS:"Печать ваучеров",
      PRINT_NEW_VOUCHERS_DESCRIPTION:"Введите префикс кода ваучера, чтобы напечатать всю серию ваучеров. альтернативно",
      PRINT_VOUCHERS_PREFIX:"Приставка ваучера (серии)",
      NO_VOUCHERS_FOR_PRINT:"Для печать не найдено никаких ваучеров, соответствующих предложенному префикса кода",
      PRINT_VOUCHERS:"Печать ваучера (ов)",
      VALIDATION_VOUCHER_CODE_FILTER:"Поисковый срок ваучер должен состоять из заглавных букв и цифр",
      FILTER_VOUCHERS_BY_CODE:"Поиск ваучеров за выкупным кодом",
      FILTER_VOUCHERS:"Поисковые ваучеры",
      WASH_BOX:"Бокс мойки",
      DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Общее количество локальных жетонов",
      TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Общие приобретенные локальные жетоны за день",
      TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Общие потраченные локальные жетоны за день",
      TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Всего предоставленных локальных жетонов в день",
      LOCAL_TOKEN:"Локальный жетон",
      GIVEN_TOKEN:"Выданные локальные жетоны",
      SOLD_TOKEN:"Продано локальные жетоны",
      SMALL_MACHINES:"Малые машины",
      R2W_Listener:"Cлушатель",
      HHANLE_DEVICE:"HHanle - Бокс мойки",
      CODE_PREFIX_EXIST:"Префикс кода уже существует",
      CODE_PREFIX_EXIST_TEXT:"Вы не можете создать новый ваучер с этим префиксом кода. Пожалуйста, установите еще один.",
      MIN_FOUR_VALIDATION:"Всего 4 символа",
      ALL_INFORMATION_1:"Вся информация о",
      ALL_INFORMATION_2:"будут потеряны",
      ASIDE_MENU_TRANSACTIONS:"Oперации",
      EXPENSES:"Расходы",
      TOPUPS:"Купленные токены",
      EXPENSES_LIST:"Список расходов",
      USER_EMAIL:"Электронная почта пользователя",
      COMPANY_NAME:"Название компании",
      TOPUPS_LIST:"Список купленных токенов",
      CONSUMER:"Consumer",
      SYSTEM_ADMIN:"System administrator",
      MERCHANT_ADMIN:"Merchant administrator",
      COMPANY_ADMIN:"Company administrator",
      FACILITY_ADMIN:"Facility administator",
      SUBSCRIBER:"Subscriber",
      CONFIGURATOR:"Configurator",
      SETUP_UNIT_SERIAL_NO:"Серийный номер",
      SETUP_UNIT_MATERIAL_NO:"Номер материала",
      SETUP_UNIT_WEBAPI_VERSION:"Версия WebApi",
      TOTAL_TURNOVER:"Оборот автомойки",
      AVAILABILITY_ALL:"Доступность",
      AVAILIBILITY:"Доступность моечных постов:",
      AVAILABILITY_VACUUMS:"Доступность пылесосов:",
      WASH_BOX_INFO:"Информация о моечных постах",
      VACUUM_CLEANER_INFO:"Информация о пылесосах",
      BREAD_CRUMBS_SERVICE:"Обслуживание",
      HOLIDAYS:"Нерабочие дни",
      HOLIDAY:"Нерабочий день",
      LIGHTS_ON:"Включить свет",
      LIGHTS_OFF:"Выключить свет",
      WASH_BOXES_ON:"Включить моечный пост",
      WASH_BOXES_OFF:"Выключить моечный пост",
      VACUUMS_ON:"Включить пылесосы",
      VACUUMS_OFF:"Выключить пылесосы",
      TURNOVER:"Оборот",
      TURNOVER_MANUAL_WASH_UNIT:"Ручной ввод оборота",
      STATUS_BAY_RUN_TIME:"Общее время работы моечного поста",
      STATUS_BAY_PROGRAM_NAME:"Название программы",
      STATUS_BAY_CREDIT:"Баланс моечного поста",
      CLOUD_KREDIT:"Облачный баланс",
      STATUS_VACUUM_RUN_TIME:"Общее время работы пылесоса",
      SHOW_SERVICE_AND_PROGRAM_INFO:"Информация об услугах объекта, программах моечных постов и текущих неисправностях",
      UNAVAILABLE:"Устройство недоступно",
      SHOW_HIDE_TABLE:"Показать/скрыть таблицу рабочего времени",
      PROGRAM_NAME:"Название программы",
      PROGRAM_OPTION:"Опция программы",
      DEVICE:"Устройство",
      QUANTITY:"Количество",
      PROGRAM_COUNTER:"Счётчик программы",
      NO_NAME:"Ссылка не имеет имени",
      COUNTER_SERVICE_DATA:"Данные обслуживания",
      NEED_SERVICE:"Требуется обслуживание",
      PROGRAM_DATA:"Данные программы моечного поста",
      CURRENT_FAULT_DATA:"Данные о текущих неисправностях",
      REFERENCE_DUE:"Крайний срок",
      REFERENCE_SECONDS:"Секунды",
      REFERENCE_NAME:"Название детали",
      WASHBOX_NAME:"Название моечного поста",
      FAULT_NAME:"Название неисправности",
      FAULT_NUMBER:"Номер неисправности",
      CURRENT_FAULT_COUNT:"Активные неисправности",
      DEVICE_NOT_INSTALLED:"Устройство не установлено",
      STATUS_READY:"Готовый статус",
      STATUS_ERROR:"Состояние ошибки",
      CONNECTION_ERROR:"Не в сети",
      UNKNOWN_RESET:"Ошибка программного обеспечения",
      SOFTWARE_RESET:"Ошибка программного обеспечения",
      EXTERNAL_PIN_RESET:"Ошибка программного обеспечения",
      RESTART_OR_BROWNOUT_OCCURRED:"Ошибка программного обеспечения",
      DEAD_RM5_CHANNEL_PIN_ERROR:"Ошибка оборудования",
      COULD_NOT_SIMULATE_COIN:"Ошибка оборудования",
      ERROR_SETTING_INHIBIT_MODE:"Ошибка оборудования",
      OFFLINE_DEVICE:"Автомойка не в сети",
      TARIFFS:"Тарифы",
      DAY:"День",
      NIGHT:"Ночь",
      VOUCHER_CODE:"Код ваучера",
      DISMISS_ALARM:"Сбросить сигнал тревоги?",
      ALARM_ACTIVE:"Активные тревоги",
      NO_ALARM_ACTIVE:"Активных тревог нет",
      ALARM_HISTORY:"История тревог",
      MANAGING_TOKENS:"Управление токенами",
      EXPIRATION_DATE:"Дата окончания срока",
      EXTEND_TOKEN_DATE:"Продлить срок действия токена для",
      DELETE_TOKENS_FOR:"Удалить токены для",
      PUMP_TYPE:"Тип насоса",
      TURN_OFF_DEVICE:"Состояние устройства",
      OPERATION_DATA:"Данные эксплуатации",
      PUMP_DATA:"Данные насоса",
      PUMP_NAME:"Название насоса",
      POINT_NAME:"Название точки",
      CHANGER_INCOME:"Общий доход разменного автомата по датам",
      SELECTED_OPEN:"Открыто в выбранное рабочее время",
      ALWAYS_OPEN:"Всегда открыты (24/7)",
      CLOSED:"Закрыто",
      CLOSED_24:"Закрыто 24 часа",
      OPENED_24:"Открыто 24 часа",
      MON:"Понедельник",
      TUE:"Вторник",
      WED:"Среда",
      THU:"Четверг",
      FRI:"Пятница",
      SAT:"Суббота",
      SUN:"Воскресенье",
      PRICING:"Цены",
      PRICE:"Цена",
      VALIDITY:"Срок действия",
      TOKEN_PACKAGES:"Пакеты токенов",
      SINGLE_WASH:"Разовая мойка",
      FACILITY_WORKING_HOURS:"Установить часы работы для выбранного объекта",
      WORKING_HOURS_ALWAYS_OPEN:"Всегда открыто",
      WORKING_HOURS_ALWAYS_CLOSE:"Закрыто оператором",
      WORKING_HOURS_CUSTOM:"Установить часы работы",
      KARCHER_ERROR_CODE:"Код ошибки тревоги",
      KARCHER_ERROR_MESSAGE_1:"Выходы электронной схемы перегружены",
      KARCHER_ERROR_MESSAGE_2:"Необходимо опорожнить маслоотделитель",
      KARCHER_ERROR_MESSAGE_4:"Сумеречный датчик неисправен.",
      KARCHER_ERROR_MESSAGE_5:"Сработало защитное реле мотора высоконапорного насоса",
      KARCHER_ERROR_MESSAGE_6:"Нарушено соединение с RDS",
      KARCHER_ERROR_MESSAGE_7:"Манометрический выключатель 'воздух' на компрессоре не сообщает о наличие давления",
      KARCHER_ERROR_MESSAGE_8:"Причина: нет соединения с электронной схемой 'MSWS'.",
      KARCHER_ERROR_MESSAGE_10:"Нет соединения с электронной схемой насоса на месте мойки 1",
      KARCHER_ERROR_MESSAGE_11:"Выходы электронной схемы на месте мойки 1 перегружены",
      KARCHER_ERROR_MESSAGE_12:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 1",
      KARCHER_ERROR_MESSAGE_13:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 1",
      KARCHER_ERROR_MESSAGE_14:"Закрепить реле высоконапорного насоса на месте мойки 1",
      KARCHER_ERROR_MESSAGE_15:"Клапан половины нагрузки моечной площадки 1 неисправен",
      KARCHER_ERROR_MESSAGE_16:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 1",
      KARCHER_ERROR_MESSAGE_17:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 1",
      KARCHER_ERROR_MESSAGE_18:"Неисправна электронная схема на месте мойки 1.",
      KARCHER_ERROR_MESSAGE_19:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 1",
      KARCHER_ERROR_MESSAGE_20:"Нет соединения с электронной схемой дистанционного управления места мойки 1",
      KARCHER_ERROR_MESSAGE_21:"Монетный аппарат на месте мойки 1 неисправен",
      KARCHER_ERROR_MESSAGE_22:"Монетный аппарат на месте мойки 1 неисправен",
      KARCHER_ERROR_MESSAGE_30:"Нет соединения с электронной схемой насоса на месте мойки 2",
      KARCHER_ERROR_MESSAGE_31:"Выходы электронной схемы на месте мойки 2 перегружены",
      KARCHER_ERROR_MESSAGE_32:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 2",
      KARCHER_ERROR_MESSAGE_33:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 2",
      KARCHER_ERROR_MESSAGE_34:"Закрепить реле высоконапорного насоса на месте мойки 2",
      KARCHER_ERROR_MESSAGE_35:"Клапан половины нагрузки моечной площадки 2 неисправен",
      KARCHER_ERROR_MESSAGE_36:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 2",
      KARCHER_ERROR_MESSAGE_37:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 2",
      KARCHER_ERROR_MESSAGE_38:"Неисправна электронная схема на месте мойки 2.",
      KARCHER_ERROR_MESSAGE_39:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 2",
      KARCHER_ERROR_MESSAGE_40:"Нет соединения с электронной схемой дистанционного управления места мойки 2",
      KARCHER_ERROR_MESSAGE_41:"Монетный аппарат на месте мойки 2 неисправен",
      KARCHER_ERROR_MESSAGE_42:"Монетный аппарат на месте мойки 2 неисправен",
      KARCHER_ERROR_MESSAGE_50:"Нет соединения с электронной схемой насоса на месте мойки 3",
      KARCHER_ERROR_MESSAGE_51:"Выходы электронной схемы на месте мойки 3 перегружены",
      KARCHER_ERROR_MESSAGE_52:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 3",
      KARCHER_ERROR_MESSAGE_53:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 3",
      KARCHER_ERROR_MESSAGE_54:"Закрепить реле высоконапорного насоса на месте мойки 3",
      KARCHER_ERROR_MESSAGE_55:"Клапан половины нагрузки моечной площадки 3 неисправен",
      KARCHER_ERROR_MESSAGE_56:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 3",
      KARCHER_ERROR_MESSAGE_57:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 3",
      KARCHER_ERROR_MESSAGE_58:"Неисправна электронная схема на месте мойки 3.",
      KARCHER_ERROR_MESSAGE_59:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 3",
      KARCHER_ERROR_MESSAGE_60:"Нет соединения с электронной схемой дистанционного управления места мойки 3",
      KARCHER_ERROR_MESSAGE_61:"Монетный аппарат на месте мойки 3 неисправен",
      KARCHER_ERROR_MESSAGE_62:"Монетный аппарат на месте мойки 3 неисправен",
      KARCHER_ERROR_MESSAGE_70:"Нет соединения с электронной схемой насоса на месте мойки 4",
      KARCHER_ERROR_MESSAGE_71:"Выходы электронной схемы на месте мойки 4 перегружены",
      KARCHER_ERROR_MESSAGE_72:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 4",
      KARCHER_ERROR_MESSAGE_73:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 4",
      KARCHER_ERROR_MESSAGE_74:"Закрепить реле высоконапорного насоса на месте мойки 4",
      KARCHER_ERROR_MESSAGE_75:"Клапан половины нагрузки моечной площадки 4 неисправен",
      KARCHER_ERROR_MESSAGE_76:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 4",
      KARCHER_ERROR_MESSAGE_77:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 4",
      KARCHER_ERROR_MESSAGE_78:"Неисправна электронная схема на месте мойки 4.",
      KARCHER_ERROR_MESSAGE_79:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 4",
      KARCHER_ERROR_MESSAGE_80:"Нет соединения с электронной схемой дистанционного управления места мойки 4",
      KARCHER_ERROR_MESSAGE_81:"Монетный аппарат на месте мойки 4 неисправен",
      KARCHER_ERROR_MESSAGE_82:"Монетный аппарат на месте мойки 4 неисправен",
      KARCHER_ERROR_MESSAGE_90:"Нет соединения с электронной схемой насоса на месте мойки 5",
      KARCHER_ERROR_MESSAGE_91:"Выходы электронной схемы на месте мойки 5 перегружены",
      KARCHER_ERROR_MESSAGE_92:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 5",
      KARCHER_ERROR_MESSAGE_93:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 5",
      KARCHER_ERROR_MESSAGE_94:"Закрепить реле высоконапорного насоса на месте мойки 5",
      KARCHER_ERROR_MESSAGE_95:"Клапан половины нагрузки моечной площадки 5 неисправен",
      KARCHER_ERROR_MESSAGE_96:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 5",
      KARCHER_ERROR_MESSAGE_97:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 5",
      KARCHER_ERROR_MESSAGE_98:"Неисправна электронная схема на месте мойки 5.",
      KARCHER_ERROR_MESSAGE_99:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 5",
      KARCHER_ERROR_MESSAGE_100:"Нет соединения с электронной схемой дистанционного управления места мойки 5",
      KARCHER_ERROR_MESSAGE_101:"Монетный аппарат на месте мойки 5 неисправен",
      KARCHER_ERROR_MESSAGE_102:"Монетный аппарат на месте мойки 5 неисправен",
      KARCHER_ERROR_MESSAGE_110:"Нет соединения с электронной схемой насоса на месте мойки 6",
      KARCHER_ERROR_MESSAGE_111:"Выходы электронной схемы на месте мойки 6 перегружены",
      KARCHER_ERROR_MESSAGE_112:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 6",
      KARCHER_ERROR_MESSAGE_113:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 6",
      KARCHER_ERROR_MESSAGE_114:"Закрепить реле высоконапорного насоса на месте мойки 6",
      KARCHER_ERROR_MESSAGE_115:"Клапан половины нагрузки моечной площадки 6 неисправен",
      KARCHER_ERROR_MESSAGE_116:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 6",
      KARCHER_ERROR_MESSAGE_117:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 6",
      KARCHER_ERROR_MESSAGE_118:"Неисправна электронная схема на месте мойки 6.",
      KARCHER_ERROR_MESSAGE_119:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 6",
      KARCHER_ERROR_MESSAGE_120:"Нет соединения с электронной схемой дистанционного управления места мойки 6",
      KARCHER_ERROR_MESSAGE_121:"Монетный аппарат на месте мойки 6 неисправен",
      KARCHER_ERROR_MESSAGE_122:"Монетный аппарат на месте мойки 6 неисправен",
      KARCHER_ERROR_MESSAGE_130:"Нет соединения с электронной схемой насоса на месте мойки 7",
      KARCHER_ERROR_MESSAGE_131:"Выходы электронной схемы на месте мойки 7 перегружены",
      KARCHER_ERROR_MESSAGE_132:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 7",
      KARCHER_ERROR_MESSAGE_133:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 7",
      KARCHER_ERROR_MESSAGE_134:"Закрепить реле высоконапорного насоса на месте мойки 7",
      KARCHER_ERROR_MESSAGE_135:"Клапан половины нагрузки моечной площадки 7 неисправен",
      KARCHER_ERROR_MESSAGE_136:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 7",
      KARCHER_ERROR_MESSAGE_137:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 7",
      KARCHER_ERROR_MESSAGE_138:"Неисправна электронная схема на месте мойки 7.",
      KARCHER_ERROR_MESSAGE_139:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 7",
      KARCHER_ERROR_MESSAGE_140:"Нет соединения с электронной схемой дистанционного управления места мойки 7",
      KARCHER_ERROR_MESSAGE_141:"Монетный аппарат на месте мойки 7 неисправен",
      KARCHER_ERROR_MESSAGE_142:"Монетный аппарат на месте мойки 7 неисправен",
      KARCHER_ERROR_MESSAGE_150:"Нет соединения с электронной схемой насоса на месте мойки 8",
      KARCHER_ERROR_MESSAGE_151:"Выходы электронной схемы на месте мойки 8 перегружены",
      KARCHER_ERROR_MESSAGE_152:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 8",
      KARCHER_ERROR_MESSAGE_153:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 8",
      KARCHER_ERROR_MESSAGE_154:"Закрепить реле высоконапорного насоса на месте мойки 8",
      KARCHER_ERROR_MESSAGE_155:"Клапан половины нагрузки моечной площадки 8 неисправен",
      KARCHER_ERROR_MESSAGE_156:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 8",
      KARCHER_ERROR_MESSAGE_157:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 8",
      KARCHER_ERROR_MESSAGE_158:"Неисправна электронная схема на месте мойки 8.",
      KARCHER_ERROR_MESSAGE_159:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 8",
      KARCHER_ERROR_MESSAGE_160:"Нет соединения с электронной схемой дистанционного управления места мойки 8",
      KARCHER_ERROR_MESSAGE_161:"Монетный аппарат на месте мойки 8 неисправен",
      KARCHER_ERROR_MESSAGE_162:"Монетный аппарат на месте мойки 8 неисправен",
      KARCHER_ERROR_MESSAGE_170:"Отсутствует связь с электроникой А2",
      KARCHER_ERROR_MESSAGE_171:"Перегружены выходы электроники А2",
      KARCHER_ERROR_MESSAGE_172:"Бак для моющего средства пуст",
      KARCHER_ERROR_MESSAGE_173:"Бак для моющего средства пуст",
      KARCHER_ERROR_MESSAGE_174:"Бак для моющего средства пуст",
      KARCHER_ERROR_MESSAGE_175:"Бак для моющего средства пуст",
      KARCHER_ERROR_MESSAGE_176:"Бак для моющего средства пуст",
      KARCHER_ERROR_MESSAGE_177:"Слишком высокое потребление электроэнергии насоса для мойки основания пола",
      KARCHER_ERROR_MESSAGE_178:"Отсутствует давление после включения мойки днища",
      KARCHER_ERROR_MESSAGE_190:"Отсутствует связь с электроникой А3",
      KARCHER_ERROR_MESSAGE_191:"Перегружены выходы электроники А3",
      KARCHER_ERROR_MESSAGE_200:"Отсутствует связь между управлением и электроникой WSO",
      KARCHER_ERROR_MESSAGE_201:"Перегружены выходы управления к WSO",
      KARCHER_ERROR_MESSAGE_202:"Датчик жесткости воды указывает на проведение регенерации жесткой воды",
      KARCHER_ERROR_MESSAGE_204:"Неисправность электронной схемы",
      KARCHER_ERROR_MESSAGE_210:"Активирован выключатель уровня «ПРОМЕЖУТОЧНЫЙ РЕЗЕРВУАР ПУСТ»",
      KARCHER_ERROR_MESSAGE_211:"Выключатели уровня 'ПРОМЕЖУТОЧНЫЙ РЕЗЕРВУАР ПУСТ' и 'ПРОМЕЖУТОЧНЫЙ РВУАР ЗАПОЛНЕН' переключаются одновременно",
      KARCHER_ERROR_MESSAGE_212:"Выключатели уровня 'ОБРАТНООСМОТИЧЕСКИЙ НАСОС ВКЛЮЧЕН' и 'ПРОМЕЖУТОЧНЫЙ РЕЗЕРВУАР ЗАПОЛНЕН' переключаются одновременно",
      KARCHER_ERROR_MESSAGE_213:"Отсутствует давление воды",
      KARCHER_ERROR_MESSAGE_214:"Сообщение о неисправности заводской установки водоподготовки",
      KARCHER_ERROR_MESSAGE_220:"Недостаток воды",
      KARCHER_ERROR_MESSAGE_221:"Слишком высокая температура выхлопных газов",
      KARCHER_ERROR_MESSAGE_222:"Слишком высокое потребление электроэнергии циркуляционного насоса системы теплой воды",
      KARCHER_ERROR_MESSAGE_223:"Неисправность горелки",
      KARCHER_ERROR_MESSAGE_224:"Сработал автоматический предохранитель горелки",
      KARCHER_ERROR_MESSAGE_225:"Задержка горелки активна",
      KARCHER_ERROR_MESSAGE_226:"Индикатор потока открывает подачу воды после отключения циркуляционного насоса подачи теплой воды не более, чем на 5 секунд.",
      KARCHER_ERROR_MESSAGE_227:"Индикатор потока перекрывает подачу воды после включения циркуляционного насоса подачи теплой воды не более, чем на 3 секунд.",
      KARCHER_ERROR_MESSAGE_228:"Выход горячей воды слишком медленно охлаждается после отключения горелки",
      KARCHER_ERROR_MESSAGE_229:"Неисправность датчика температуры горячей воды",
      KARCHER_ERROR_MESSAGE_230:"Неисправность датчика температуры на выходе горелки",
      KARCHER_ERROR_MESSAGE_231:"Неисправность датчика температуры горячей воды",
      KARCHER_ERROR_MESSAGE_232:"Неисправность датчика температуры на выходе горелки",
      KARCHER_ERROR_MESSAGE_233:"Температура воды при внешней подаче теплой воды выше 60°C",
      KARCHER_ERROR_MESSAGE_234:"Ошибка в программе «антилегионелла»",
      KARCHER_ERROR_MESSAGE_235:"Температура горячей воды в режиме «антилегионелла» не достигнута",
      KARCHER_ERROR_MESSAGE_240:"Неисправность датчика наружной температуры",
      KARCHER_ERROR_MESSAGE_241:"Неисправность датчика наружной температуры",
      KARCHER_ERROR_MESSAGE_242:"Слишком высокое потребление электроэнергии циркуляционного насоса системы защиты от замерзания",
      KARCHER_ERROR_MESSAGE_243:"Слишком высокое потребление электроэнергии циркуляционного насоса системы обогрева места мойки",
      KARCHER_ERROR_MESSAGE_244:"Температура теплой воды слишком низкая, не выключать обогрев места мойки",
      KARCHER_ERROR_MESSAGE_245:"Потребление тока обогревом шланга подачи пены слишком высокое",
      KARCHER_ERROR_MESSAGE_247:"Неисправность электронной схемы",
      KARCHER_ERROR_MESSAGE_248:"Неисправность электронной схемы",
      KARCHER_ERROR_MESSAGE_250:"Слишком высокое потребление электроэнергии насоса при активации особых программ мойки",
      KARCHER_ERROR_MESSAGE_255:"Неисправность электронной схемы",
      KARCHER_ERROR_MESSAGE_260:"Отсутствует связь с электроникой А5",
      KARCHER_ERROR_MESSAGE_261:"Перегружены выходы электроники А5",
      KARCHER_ERROR_MESSAGE_280:"Отсутствует связь с электроникой А6",
      KARCHER_ERROR_MESSAGE_281:"Перегружены выходы электроники А6",
      KARCHER_ERROR_MESSAGE_282:"Потребление тока насоса устройства для мойки колесных дисков слишком высокое",
      KARCHER_ERROR_MESSAGE_283:"Потребление тока насоса устройства для мойки колесных дисков слишком низкое",
      KARCHER_ERROR_MESSAGE_284:"Реле насоса устройства для мойки колесных дисков заклинивает",
      KARCHER_ERROR_MESSAGE_300:"Отсутствует связь с электроникой А7",
      KARCHER_ERROR_MESSAGE_301:"Перегружены выходы электроники А7",
      KARCHER_ERROR_MESSAGE_320:"Отсутствует связь с электроникой А8",
      KARCHER_ERROR_MESSAGE_321:"Перегружены выходы электроники А8",
      KARCHER_ERROR_MESSAGE_322:"Потребление тока насосом микроэмульсии слишком высокое",
      KARCHER_ERROR_MESSAGE_323:"Потребление тока насосом микроэмульсии слишком низкое",
      KARCHER_ERROR_MESSAGE_324:"Реле насоса микроэмульсии закли нивает",
      KARCHER_ERROR_MESSAGE_340:"Отсутствует связь с электроникой А9",
      KARCHER_ERROR_MESSAGE_341:"Перегружены выходы электроники А9",
      KARCHER_ERROR_MESSAGE_342:"Слишком высокое потребление электроэнергии насосом для интенсивной очистки",
      KARCHER_ERROR_MESSAGE_343:"Слишком низкое потребление электроэнергии насосом для интенсивной очистки",
      KARCHER_ERROR_MESSAGE_344:"Реле насоса для интенсивной очистки заклинивает",
      KARCHER_ERROR_MESSAGE_400:"Отсутствует давление горячей воды",
      KARCHER_ERROR_MESSAGE_401:"Отсутствует давление свежей воды",
      KARCHER_ERROR_MESSAGE_402:"Отсутствует давление пермеата",
      KARCHER_ERROR_MESSAGE_403:"4. Отсутствует давление 4-го типа воды",
      KARCHER_ERROR_MESSAGE_404:"4. Тип воды, температура выше 60 °C или внешний сбой",
      KARCHER_ERROR_MESSAGE_405:"Защита от замерзания без давления",
      KARCHER_ERROR_MESSAGE_406:"Давление в системе защиты от замерзания несмотря на выключенный насос защиты от замерзания",
      KARCHER_ERROR_MESSAGE_410:"Ошибка F 400 возникла 4 раза в течение 24 часов",
      KARCHER_ERROR_MESSAGE_411:"Ошибка F 401 активна в течение 300 секунд",
      KARCHER_ERROR_MESSAGE_412:"Ошибка F 402 возникла 4 раза в течение 24 часов",
      KARCHER_ERROR_MESSAGE_413:"Ошибка F 403 возникла 4 раза в течение 24 часов",
      KARCHER_ERROR_MESSAGE_414:"Ошибка F 405 возникла 4 раза в течение 24 часов",
      KARCHER_ERROR_MESSAGE_420:"Неисправность переключателя стоимости монет 1",
      KARCHER_ERROR_MESSAGE_421:"Неисправность переключателя стоимости монет 2",
      KARCHER_ERROR_MESSAGE_440:"Отсутствует связь с электроникой А31",
      KARCHER_ERROR_MESSAGE_441:"Перегружены выходы электроники А31",
      KARCHER_ERROR_MESSAGE_500:"Соединение с электронными компонентами пылесоса 1/2",
      KARCHER_ERROR_MESSAGE_501:"Кнопка пуска пылесоса 1 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_502:"Кнопка пуска пылесоса 2 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_510:"Соединение с электронными компонентами пылесоса 3/4",
      KARCHER_ERROR_MESSAGE_511:"Кнопка пуска пылесоса 3 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_512:"Кнопка пуска пылесоса 4 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_520:"Соединение с электронными компонентами пылесоса 5/6",
      KARCHER_ERROR_MESSAGE_521:"Кнопка пуска пылесоса 5 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_522:"Кнопка пуска пылесоса 6 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_530:"Соединение с электронными компонентами пылесоса 7/8",
      KARCHER_ERROR_MESSAGE_531:"Кнопка пуска пылесоса 7 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_532:"Кнопка пуска пылесоса 8 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_540:"Соединение с электронными компонентами пылесоса 9/10",
      KARCHER_ERROR_MESSAGE_541:"Кнопка пуска пылесоса 9 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_542:"Кнопка пуска пылесоса 10 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_550:"Соединение с электронными компонентами пылесоса 10/11",
      KARCHER_ERROR_MESSAGE_551:"Кнопка пуска пылесоса 11 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_552:"Кнопка пуска пылесоса 12 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_800:"Отсутствует связь с электроникой А30",
      KARCHER_ERROR_MESSAGE_801:"Перегружены выходы электроники А30",
      KARCHER_ERROR_MESSAGE_802:"Сбой устройства смягчения",
      KARCHER_ERROR_MESSAGE_803:"Выключатель защиты двигателя, насос предварительного давления ОО запущен",
      KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
      KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
      KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
      KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
      KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
      KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
      KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
      KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
      KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
      KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
      KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
      KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
      KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
      KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
      KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
      KARCHER_INFO_MESSAGE_20:"Программа «антилегионелла» бака для горячей воды",
      KARCHER_INFO_MESSAGE_21:"Программа «антилегионелла» насоса высокого давления 1 выполнена успешно",
      KARCHER_INFO_MESSAGE_22:"Программа «антилегионелла» насоса высокого давления 2 выполнена успешно",
      KARCHER_INFO_MESSAGE_23:"Программа «антилегионелла» насоса высокого давления 3 выполнена успешно",
      KARCHER_INFO_MESSAGE_24:"Программа «антилегионелла» насоса высокого давления 4 выполнена успешно",
      KARCHER_INFO_MESSAGE_25:"Программа «антилегионелла» насоса высокого давления 5 выполнена успешно",
      KARCHER_INFO_MESSAGE_26:"Программа «антилегионелла» насоса высокого давления 6 выполнена успешно",
      KARCHER_INFO_MESSAGE_27:"Программа «антилегионелла» насоса высокого давления 7 выполнена успешно",
      KARCHER_INFO_MESSAGE_28:"Программа «антилегионелла» насоса высокого давления 8 выполнена успешно",
      KARCHER_INFO_MESSAGE_29:"Программа «антилегионелла» завершена",
      KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
      KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
      KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
      KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
      KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
      KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
      KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
      KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
      KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
      KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
      KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
      KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
      KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
      KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
      KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
      KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
      KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
      KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
      KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
      KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
      KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
      KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
      KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
      KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
      KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
      KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
      KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
      KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
      KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
      KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
      KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
      KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
      KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
      KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
      KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
      KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
      KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
      KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
      KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
      KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
      KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
      KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
      KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
      KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
      KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
      ORGANIZATION:"Organizacija",
      CREATE_ORGANIZATION:"Создать организацию",
      CREATE_ORGANIZATION_AS:"Создать дочернюю организацию для",
      DELETE_ORGANIZATION:"Удалить организацию",
      EDIT_ORGANIZATION:"Редактировать организацию",
      SUPPORTED_ORG_NAME:"Поддерживаемая организация",
      SUPPORTED_ORG_TYPE:"Поддерживаемый тип",
      ORG_NAME:"Название",
      ORG_TYPE:"Тип",
      SET_ORG_TITLE:"Назначить дочернюю организацию",
      SET_SUPPORTED_ORG_TITLE:"Назначить поддерживаемую дочернюю организацию",
      SAVE_ORGANIZATION:"Сохранить организацию",
      SELECT_ORGANIZATION_TYPE:"Выберите тип организации",
      SELECT_ORGANIZATION_SELECTOR:"Выбрать",
      SELECT_SUPPORTED_ORGANIZATION:"Поддерживается",
      ORGANIZATION_DELETED:"Организация успешно удалена",
      ORGANIZATION_SAVED:"Организация успешно сохранена",
      ORGANIZATION_UPDATED:"Организация успешно обновлена",
      ALERTS:"Тревоги",
      DEVICE_STATUS:"Состояние устройства",
      SITE_DETAILS:"Сведения об объекте",
      ALARM_STATUS:"Статус тревоги",
      FILTER:"Фильтр по ...",
      FILTER_BY_ALERT_CENTER:"Фильтр по коду, названию или описанию",
      TOTAL_ALARM:"Всего",
      LOW_ALARM:"Событие",
      MEDIUM_ALARM:"Неисправность",
      HIGH_ALARM:"Критическая неисправность",
      NO_FACILITIES_NEARBY:"Поблизости нет объектов",
      GRAY_MAP:"Карта в серых тонах",
      READY:"Готово",
      WARNING:"Неисправность",
      ERROR:"Ошибка",
      SITE_NAME:"Название объекта",
      ACCOUNTS_INFO:"Информация об учетной записи",
      USER_ORGANIZATION:"Организация пользователя",
      ADD_USER_ORGANIZATION:"Добавить нового пользователя организации",
      EDIT_USER_ORGANIZATION:"Редактировать пользователей организации",
      SELECT_ROLE:"Выберите роль",
      SELECT_ORGANIZATION:"Выберите организацию",
      SELECT_USER:"Выберите пользователя",
      USER_FOR_ORGANIZATION_CREATED:"Новый пользователь успешно создан",
      SELECT_REGION:"Выберите регион",
      SELECT_LANGUAGE:"Выберите язык",
      LOADING_DATA:"Загрузка данных, пожалуйста, подождите ...",
      ADMINISTRATOR:"Администратор",
      TECHNICAL_SUPPORT:"Техническая поддержка",
      CONTROLLER:"Контролёр",
      EDIT_ORGANIZATION_USER:"Редактировать пользователей организации",
      DELETE_ORGANIZATION_USER:"Удалить пользователей организации",
      USER_UPDATED:"Пользователь успешно обновлён",
      USER_CREATED:"Пользователь успешно создан",
      ADDRESS:"Адрес",
      SUBSCRIPTIONS:"Подписки",
      RESOLVED_STATUS:"Решено",
      NOT_RESOLVED_STATUS:"Не решено",
      ALERT_NAME:"Название оповещения",
      ALERT_DESCRIPTION:"Описание оповещения",
      ALERT_CODE:"Код оповещения",
      ALERT_TYPE:"Тип оповещения",
      UNSUBSCRIBE:"Отписаться от оповещения",
      SUBSCRIBE:"Подписаться на оповещение",
      ALARM_SUBSCRIBED:"Подписка успешно оформлена",
      UNSUBSCRIBED_CONFIRM:"Отписаться?",
      ALARM_UNSUBSCRIBED:"Вы успешно отписались",
      ASIDE_MENU_CASHLESS_SALES:"Безналичные продажи",
      FILTERED_CASHLESS_PAYMENTS:"Отфильтрованные безналичные платежи",
      REFUND_DIALOG_TITLE:"Сделать возврат по транзакции?",
      REFUND_DIALOG_SUBTITLE:"Сумма может быть меньше либо равна сумме транзакции",
      REFUND:"Возврат",
      INPUT_NOT_VALID:"Некорректный ввод",
      REFUND_SUCCESSFULLY:"Возврат по выбранному платежу успешно выполнен",
      USER:"Пользователь",
      TRANSACTION_ID:"PSP-идентификатор",
      DEVICE_ID:"ID устройства",
      NET_AMOUNT:"Чистая сумма",
      TRANSACTION_STATUS:"Статус транзакции",
      REPORT_NAME:"Название отчёта",
      TIME_FRAME:"Период времени",
      SUB_POINT:"Выберите дочернюю точку",
      SUB_POINT_LIST_NOT_EXIST:"Список дочерних точек отсутствует для выбранного объекта автомойки",
      FACILITY_TYPE:"Тип объекта",
      MACHINE_NAME:"Название машины",
      WASH_FACILITY_DETAILS:"Сведения об объекте автомойки",
      WASH_BAY_DETAILS:"Сведения о моечном посту",
      DEVICES_INFO:"Список устройств",
      OPERATION_TIME_INFO:"Время работы",
      OPERATION_TIME_VACUUM_INFO:"Время работы пылесосов",
      OPERATION_TIME_ILLUMINATION_INFO:"Время работы освещения",
      AVAILABLE_TITLE:"Доступно",
      UNAVAILABLE_TITLE:"Недоступно",
      CURRENT_PROGRAM:"Текущая программа",
      CREDITS:"Баланс",
      DEVICE_NAME:"Название устройства",
      ACTIVE_ALARMS:"Активные тревоги",
      ALL_DAY:"Весь день",
      OPERATING_TIME_WASH_FACILITY:"Система самообслуживания мойки",
      OPERATING_TIME_VACUUMS:"Пылесосы",
      OPERATING_TIME_ILLUMINATION:"Освещение",
      OPERATION_COUNTERS:"Счётчики работы",
      EDIT:"Редактировать",
      WASHING_PROGRAMS:"Программы мойки",
      INFO:"Событие",
      STATISTIC:"Статистика",
      ROLLOVER_DOSING:"Dosing",
      ROLLOVER_SPEED:" Speeds",
      ROLLOVER_RESETS:" Rollover remote reset",
      ROLLOVER_RESETS_INFO:" The remote reset has to be in accordance with local regulations. Important: Before resetting make sure that rollover is empty.",
      RESET_ROLLOVER:" Reset rollover",
      OPEN_DOOR_ROLLOVER:" Open",
      ROLLOVER_OPEN_DOOR_INFO:"Open wash hall door. Be careful.",
      ROLLOVER_OPEN_DOOR:" Open the door",
      APPLY_DOSING_CHANGES:" Apply dosing changes",
      APPLY_SPEED_CHANGES:" Apply speed changes",
      ACTUATION_SUCCESS:"Request sent",
      REMAINING_TIME:" Remaining time",
      OPEN_24H:"Открыто 24 часа",
      CLOSE_24H:"Закрыто 24 часа",
      VALIDATION_OPERATION_TIME:" Format not correct. Use hh:mm",
      ROLLOVER:" Rollover",
      UPDATE_WASHING_PROGRAM:" Update washing program",
      UPDATE_ACTUATORS:"Update actuators",
      OPEN_ROLOVER_DOOR_TITLE:" Want to open rollover door?",
      OPEN_ROLOVER_DOOR_CONTENT:" Are you sure you want to open the door?",
      RESET_ROLOVER_TITLE:" Want to reset rollover?",
      RESET_ROLOVER_CONTENT:" Are you sure you want to reset rollover?",
      G0:"G0",
      G1:"G1",
      G2:"G2",
      G3:"G3",
      G4:"G4",
      G5:"G5",
      G6:"G6",
      G7:"G7",
      G8:"G8",
      G9:"G9",
      G10:"G10",
      U0:"U0",
      U1:"U1",
      U2:"U2",
      U3:"U3",
      U4:"U4",
      U5:"U5",
      U6:"U6",
      U7:"U7",
      ALERT_CENTER_TITLE_BY_SITE:" Alert center report created by selected site from dashboard",
      ALERT_CENTER_TITLE_BY_FACILITY:" Alert center report created by selected facility from dashboard",
      ALERT_CENTER_TITLE_BY_DEFAULT:" Alert center report",
      ERROR_MESSAGE_403:" You don't have privilege to use this api call. Error Code: 403",
      LAST_ACTIVE_PROGRAM:"Active program / Last active program",
      PROGRAM_ID:"Номер программы",
      PROGRAM_PRICE:"Цена программы",
      PROGRAM_DESCRIPTION:"Описание программы",
      NORMAL_CHEMICAL_LEVEL:"OK",
      LOW_CHEMICAL_LEVEL:"Refill required",
      EMPTY_CHEMICAL_LEVEL:"Empty",
      CHEMICAL_LEVEL:"Level indication detergents (%)",
      ROLLOVER_STATUS:" Rollover status",
      ROLLOVER_STATUS_CODE_0:" Wash currently out of order",
      ROLLOVER_STATUS_CODE_1:" Outside operating time",
      ROLLOVER_STATUS_CODE_2:" Program entry allowed",
      ROLLOVER_STATUS_CODE_3:"Position your vehicle",
      ROLLOVER_STATUS_CODE_4:"Vehicle forwards",
      ROLLOVER_STATUS_CODE_5:"Vehicle back",
      ROLLOVER_STATUS_CODE_6:"Vehicle stop",
      ROLLOVER_STATUS_CODE_7:"Wash active",
      ROLLOVER_STATUS_CODE_8:"Wash stopped",
      ROLLOVER_STATUS_CODE_9:"Wash active (tact)",
      ROLLOVER_STATUS_CODE_10:"Exit vehicle backwards",
      ROLLOVER_STATUS_CODE_11:"Emergency stop",
      ROLLOVER_STATUS_CODE_12:"Exit vehicle forward",
      ROLLOVER_STATUS_CODE_13:"Anti frost active",
      ROLLOVER_STATUS_CODE_14:"Safety switch front activated",
      ROLLOVER_STATUS_CODE_15:"Safety switch rear activated",
      ROLLOVER_STATUS_CODE_16:"Safety switch left front side activated",
      ROLLOVER_STATUS_CODE_17:" Safety switch right front side activated",
      ROLLOVER_STATUS_CODE_18:" Safety switch left rear side activated",
      ROLLOVER_STATUS_CODE_19:"Safety switch right rear side activated",
      ROLLOVER_STATUS_CODE_20:"Vehicle position too far left hand side",
      ROLLOVER_STATUS_CODE_21:" Vehicle position too far right hand side",
      ROLLOVER_STATUS_CODE_22:"Left door not closed",
      ROLLOVER_STATUS_CODE_23:" Right door not closed",
      ROLLOVER_STATUS_CODE_24:"Transporter detected, wrong wash program selected",
      ROLLOVER_STATUS_CODE_25:" Horn sensor",
      ROLLOVER_STATUS_CODE_98:"Manual / adjustment mode",
      ROLLOVER_STATUS_CODE_99:" Unknown status",
      ROLLOVER_STATUS_CODE_UNDEFINED:"Status code undefined",
      ALARM:"Критическая неисправность",
      NO_ALARM:"Нет критических неисправностей",
      SOFTWARE_VERSION:"Версия ПО",
      SOFTWARE_DATE:"Дата версии ПО",
      SITE_ADDRESS:"Адрес объекта",
      SECONDS:"Секунды",
      SERVICE_PART_NAME:"Название обслуживания:",
      OPERATION_SERVICE_COUNTER_ROLLOVER:"Счётчик эксплуатации и обслуживания",
      OPERATION_COUNTER:"Счётчик эксплуатации",
      SERVICE_COUNTER:"Счётчик обслуживания",
      FAULT_CODE:"Код оповещения",
      PRESSURE_TITLE:"Давление воздуха",
      TIME_TITLE:"Текущее время",
      COUNTRY_TITLE:"Страна",
      CITY_TITLE:"Город",
      REGION_TITLE:"Регион",
      SELECT_POINTS_TO_SEARCH:"Выберите точки ...",
      LOGS_HISTORY:"История изменений параметров",
      ACTUATOR_REFERENCE:"Ссылка на исполнительный механизм",
      ACTUATOR_VALUE:"Значение исполнительного механизма",
      POINT_ID:"ID точки",
      VALIDATION_NOT_VALID_RANGE:"Недопустимый диапазон",
      ENABLE_ROLLOVER_RESET:"Отмечая этот флажок, вы подтверждаете, что прочитали и согласны с инструкциями по технике безопасности.",
      CHANGE_OF_PARAMETERS:"Изменение параметров",
      SELECT_OPTIONS:"Выберите параметры",
      AUTOMATIC:"Автоматический",
      DESALTING:"Функция удаления соли",
      SEASON_WASH:"Сезонные программы мойки",
      SPRING_PROGRAM:"Весенние программы мойки",
      SUMMER_PROGRAM:"Летние программы мойки",
      AUTUMN_PROGRAM:"Осенние программы мойки",
      WINTER_PROGRAM:"Зимние программы мойки",
      DOOR_CONTROL:"Управление воротами",
      SUMMER_DOOR_CONTROL:"Лето: управление воротами в летнем режиме",
      WINTER_DOOR_CONTROL:"Зима: управление воротами в зимнем режиме",
      APPLY_PARAMETERS_CHANGES:"Применить изменения параметров",
      WORKING_SCHEDULES:"Графики работы",
      HOLIDAY_SCHEDULES:"Расписания праздничных дней",
      SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Праздничные дни на объекте успешно созданы",
      SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Праздничные дни на объекте успешно обновлены",
      SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Праздничные дни на объекте успешно удалены",
      WORKING_SCHEDULES_SUCCESSFULLY_UPDATED:"Графики работы на объекте успешно обновлены",
      WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Рабочие расписания успешно применены",
      HOLIDAY_SUCCESSFULLY_DELETED:"Праздничный день успешно удалён",
      SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
      SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
      SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
      SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
      SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
      SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
      SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
      SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
      SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
      SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
      SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
      SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
      CB3_1_0_0:"CB3_1_0_0_Trans",
      CW35_3_0_0:"CW35_3_0_0_Trans",
      CW35_3_1_0:"CW35_3_1_0_Trans",
      CWB3_3_0_0:"CWB3_3_0_0_Trans",
      CWB3_3_1_0:"CWB3_3_1_0_Trans",
      CW1_3_0_0:"CW1_3_0_0_Trans",
      CW1_3_1_0:"CW1_3_1_0_Trans",
      CHEM_LEVEL_LOW_DRYING_AGENT:"Drying agent with low filling level",
      CHEM_LEVEL_LOW_SHAMPOO:"Shampoo with low filling level",
      CHEM_LEVEL_LOW_FOAM:"Foam with low filling level",
      CHEM_LEVEL_LOW_WAX_1:"Wax with low filling level",
      CHEM_LEVEL_LOW_POLISH_1:"Polish with low filling level",
      CHEM_LEVEL_LOW_RIM_CLEANER:"Rim cleaner with low filling level",
      CHEM_LEVEL_LOW_WAX_2:"Wax with low filling level",
      CHEM_LEVEL_LOW_TYRE_SHINE:"Tyre shine with low filling level",
      CHEM_LEVEL_LOW_INSECT_REMOVER:"Insect remover with low filling level",
      CHEM_LEVEL_LOW_POLISH_2:"Polish with low filling level",
      CHEM_LEVEL_LOW_INTENSIVE:"Intensive with low filling level",
      CHEM_LEVEL_LOW_FOAM_RAIN:"Foam rain with low filling level",
      CHEM_LEVEL_DRYING_AGENT:"Filling level drying agent",
      CHEM_LEVEL_SHAMPOO:"Filling level shampoo",
      CHEM_LEVEL_FOAM:"Filling level foam",
      CHEM_LEVEL_WAX_1:"Filling level wax",
      CHEM_LEVEL_POLISH_1:"Filling level polish",
      CHEM_LEVEL_RIM_CLEANER:"Filling level rim cleaner",
      CHEM_LEVEL_WAX_2:"Filling level wax",
      CHEM_LEVEL_TYRE_SHINE:"Filling level tyre shine",
      CHEM_LEVEL_INSECT_REMOVER:"Filling level insect remover",
      CHEM_LEVEL_POLISH_2:"Filling level polish",
      CHEM_LEVEL_INTENSIVE:"Filling level intensive ",
      CHEM_LEVEL_FOAM_RAIN:"Filling level foam rain",
      SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Service counter roof-brush lifting belt",
      SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Service counter dryer lifting belt",
      SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Service counter motor cable roof-brush",
      SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Service counter fresh water pump service",
      SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Service counter pump service used water",
      DRYING_AGENT:"Средство для сушки",
      FOAM_DRYING_AGENT:"Пенное средство для сушки",
      SHAMPOO:"Шампунь",
      FOAM:"Пена",
      BRUSH_FOAM:"Щеточная пена",
      WAX_1:"Воск",
      FOAM_WAX_1:"Пенный воск",
      POLISH_1:"Полировка",
      RIM_CLEANING:"Очиститель дисков",
      WAX_2:"Воск",
      FOAM_WAX_2:"Пенный воск",
      TYRE_SHINE:"Блеск шин",
      INSECT_REMOVER:"Удалитель насекомых",
      POLISH_2:"Полировка",
      INTENSIVE_BASIC:"Интенсивная базовая",
      INTENSIVE_SIDE:"Интенсивная базовая",
      INTENSIVE_ROOF_SPRAY_BAR:"Интенсивная верхняя мойка",
      TAR_REMOVER:"Удалитель смолы",
      UNDER_CHASSIS_CONVERSATION:"Консервация днища",
      STATIONARY_PRE_SPRAY_ARCH:"Стационарная арка предварительного распыления",
      FOAM_RAIN:"Пенный дождь",
      PRE_CLEANING:"Предварительная очистка",
      BRUSH:"Щётка",
      CARE:"Уход",
      DRYING:"Сушка",
      DRYING_LOW_NOISE:"Сушка (пониженный шум)",
      INTENSIVE_CLEANING:"Интенсивная очистка",
      BRUSH_CLEANING:"Мойка щёткой",
      EMPTY_RUN:"Холостой ход",
      DRYING_AID:"Средство для сушки",
      WAX:"Воск",
      FOAM_WASH:"Пенная мойка",
      POLISH:"Полировка",
      FOAM_POLISH:"Пенная полировка",
      WHEEL_CLEANING:"Очистка колёс",
      HIGH_PRESSURE_ROOF:"Верхняя мойка высоким давлением",
      HIGH_PRESSURE_SIDE:"Боковая мойка высоким давлением",
      DRYER_FORWARD:"Перемещение сушилки вперёд",
      DRYER_BACKWARD:"Перемещение сушилки назад",
      DELETE_ALL_HOLIDAYS:"Удалить все праздники для выбранного объекта",
      CREATE_NEW_HOLIDAY:"Создать новый",
      RESET_INPUTS:"Сбросить все поля праздников",
      TWENTY_FOUR_HOURS_OPEN:"Открыто 24 часа",
      EVERY_YEAR:"Ежегодно",
      DELETE_HOLIDAY:"Удалить праздник",
      ADD_NEW_HOLIDAY:"Добавить новый праздник",
      HOLIDAYS_LIST:"Список существующих праздников",
      DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Удалить все праздники для выбранного объекта?",
      VALIDATION_HOLIDAY_DATE:"Неверный формат. Используйте dd-mm",
      FOR_DATE:"Для даты",
      WITH_ID:"С идентификатором",
      FROM_HOURS:"С (ч)",
      FROM_MINUTES:"С (мин)",
      TO_HOURS:"До (ч)",
      TO_MINUTES:"До (мин)",
      NOT_MATCH:"Не совпадает",
      START:"Старт",
      STOP:"Стоп",
      DAILY_TIME:"24 hours list",
      INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individual time setting",
      PROGRAM_NOT_STARTED:"Program not started yet",
      JETWASH:"Self-service wash system",
      KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
      KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
      KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
      KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
      KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
      KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
      KARCHER_REPORT_7:"Rollover: Amount of power supply failures",
      KARCHER_REPORT_8:"SB-Units: Amount of hours per washing program filtered by bay and in total",
      KARCHER_REPORT_9:"SB-Units: Turnover indication per wash bay and in total",
      KARCHER_REPORT_10:"SB-Units: Tokens/Coins counter per coin channel",
      OPERATION_COUNTER_FRESH_WATER_PUMP:"Насос чистой воды",
      OPERATION_COUNTER_PROCESS_WATER_PUMP:"Насос оборотной воды",
      OPERATION_COUNTER_HP_PUMP_1:"Насос высокого давления 1",
      OPERATION_COUNTER_HP_PUMP_2:"Насос высокого давления 2",
      RELEASE_NOTES:"Версии приложения и примечания к выпуску",
      BACKEND_RELEASE_NOTES:"Примечания к выпуску платформы:",
      FRONTEND_RELEASE_NOTES:"Примечания к выпуску веб-приложения:",
      SELECTED_FACILITY_TIMEZONE:"Часовой пояс для выбранного объекта:",
      REFRESH_PAGE:"Обновить страницу",
      REFRESH_MAPS:"Refresh maps",
      PUMPS:"Pumps",
      RUN_TIME:"Run time",
      RUN_TIME1:"Run time 1",
      RUN_TIME2:"Run time 2",
      PROGRAM_RUNTIME_ACTUATOR:"Actuator for run time",
      PROGRAM_RUNTIME_ACTUATOR_1:"Actuator for run time 1",
      PROGRAM_RUNTIME_ACTUATOR_2:"Actuator for run time 2",
      PUMP_RUN_TIME_MIN_VALIDATION:"Min value is 1",
      PUMP_RUN_TIME_MAX_VALIDATION:"Max value is 255",
      WASH_PROGRAM_MIN_MAX_VALIDATION:"Use price format x.xx",
      ACTUATION_NOT_ALLOWED:" Actuation not allowed for current user role",
      MAINTENANCE_DAYS:"Maintenance days",
      MAINTENANCE_WASHES:"Maintenance washes",
      DAILY_FINANCES_POS:"POS",
      POS_INCOME:"Общий доход POS",
      PROPAGATE:"Распространить",
      ALL_DAY_HOURS_SELECTOR:"Переключатель режима «24 часа»",
      GET_OPERATING_TIME_FROM_SITE:"Получить время работы текущего устройства из графиков работы объекта",
      USER_NOT_VALID:"Пользователь недействителен. Попробуйте другие учетные данные.",
      VERIFIED:"Подтверждён",
      RESEND_VERIFICATION_MAIL:"Отправить письмо с подтверждением повторно",
      RETURN_TO_DASHBOARD:"Вернуться к панели управления",
      ERROR_PAGE_BAD_REQUEST:"400 Неверный запрос.",
      WASHES:"Количество моек",
      TIME_TO_SERVICE:"Время до обслуживания",
      ACCOUNT_ALREADY_ACTIVATED:"Учетная запись уже активирована",
      DEVICE_EVENTS:"События устройства",
      DEVICE_EVENTS_LOG_PULLED:"Получен журнал событий для устройства",
      EVENTS_PULL_DATE:"Время получения событий:",
      DEVICE_EVENTS_REFRESH:"Получить новые данные о событиях",
      WEB_SOCKETS_CONNECTION_PROBLEM:"Проблема с WebSocket-соединением. Попробуйте обновить страницу.",
      INSTALLATION_DATE:"Дата установки машины",
      KARCHER_CUSTOM_PROGRAM_NAME_1:"Hot wax",
      KARCHER_CUSTOM_PROGRAM_NAME_2:"High pressure washing",
      KARCHER_CUSTOM_PROGRAM_NAME_3:"Power rim foam",
      KARCHER_CUSTOM_PROGRAM_NAME_4:"Power foam",
      KARCHER_CUSTOM_PROGRAM_NAME_5:"Stop",
      KARCHER_CUSTOM_PROGRAM_NAME_6:"Foam wash HD",
      KARCHER_CUSTOM_PROGRAM_NAME_7:"Wash",
      KARCHER_CUSTOM_PROGRAM_NAME_8:"Top care",
      INFO_TITLE:"Info",
      FOAM_WAX1:"Foam wax",
      POLISH1:"Polish",
      WAX1:"Wax",
      SITE_DETAILS_SUCCESSFULLY_UPDATED:"Сведения об объекте успешно обновлены",
      COMPANY:"Компания",
      FACILITY_HAS_CHANGER:"Есть разменный автомат?",
      DISABLE_OFFLINE_ALARM:"Отключить тревоги R2W",
      ASIDE_WORKING_SCHEDULES:"Сведения об объекте в приложении",
      TERMS_OF_SERVICE_R2W_TITLE:"Условия использования Ready2Wash",
      TERMS_OF_SERVICE_R2W:"Условия использования Ready2Wash",
      DATA_PROCESSING_TITLE:"Обрабатываемые данные",
      PRIVACY_POLICY_TITLE:"Политика конфиденциальности",
      READY_TO_PAY_TERMS_OF_SERVICE:"Условия использования Ready2Pay",
      TERMS_AND_SERVICES:"Условия и услуги",
      HOURLY:"Ежечасно",
      DAILY:"Ежедневно",
      WEEKLY:"Еженедельно",
      MONTHLY:"Ежемесячно",
      YEARLY:"Ежегодно",
      DELETE_ITEM_SUCCESS:"Элемент успешно удалён",
      STATE:"Штат",
      AVAILABILITY_STATUS_1:"Unit open",
      AVAILABILITY_STATUS_2:"Unit closed (holiday)",
      AVAILABILITY_STATUS_3:"Unit closed (operating time)",
      AVAILABILITY_STATUS_4:"Unit closed (fault)",
      AVAILABILITY_STATUS_5:"Unit closed (other)",
      AVAILABILITY_VACUUMS_STATUS_1:"Vacuums not installed",
      AVAILABILITY_VACUUMS_STATUS_2:"Vacuums open",
      AVAILABILITY_VACUUMS_STATUS_3:"Vacuums closed (holiday)",
      AVAILABILITY_VACUUMS_STATUS_4:"Vacuums closed (operating time)",
      AVAILABILITY_VACUUMS_STATUS_5:"Vacuums closed (fault)",
      AVAILABILITY_VACUUMS_STATUS_6:"Vacuums closed (other)",
      ECOM_AMOUNT:"Итого ECOM по всем объектам",
      CAPTURED:"Захвачено",
      VALUE_DATE:"Дата валютирования",
      VALIDATION_HOLIDAY_YEAR:"Format not correct. Use yyyy",
      KARCHER_EVENT_NAME_1:"Base exchanger regenerated",
      KARCHER_EVENT_NAME_2:"Base exchanger regeneration ended",
      KARCHER_EVENT_NAME_3:"Material / serial number",
      KARCHER_EVENT_NAME_4:"The system has been disinfected",
      KARCHER_EVENT_NAME_5:"HP pump 1 has been disinfected",
      KARCHER_EVENT_NAME_6:"HP pump 2 has been disinfected",
      KARCHER_EVENT_NAME_7:"HP pump 3 has been disinfected",
      KARCHER_EVENT_NAME_8:"HP pump 4 has been disinfected",
      KARCHER_EVENT_NAME_9:"HP pump 5 has been disinfected",
      KARCHER_EVENT_NAME_10:"Washing station 1 locked",
      KARCHER_EVENT_NAME_11:"Washing station 2 locked",
      KARCHER_EVENT_NAME_12:"Washing station 3 locked",
      KARCHER_EVENT_NAME_13:"Washing station 4 locked",
      KARCHER_EVENT_NAME_14:"Washing station 5 locked",
      KARCHER_EVENT_NAME_15:"Washing station 6 locked",
      KARCHER_EVENT_NAME_16:"Washing station 7 locked",
      KARCHER_EVENT_NAME_17:"Washing station 8 locked",
      KARCHER_EVENT_NAME_18:"Update started",
      KARCHER_EVENT_NAME_19:"Update finished",
      KARCHER_EVENT_NAME_20:"Start WS Reg",
      KARCHER_EVENT_NAME_21:"End WS Reg",
      KARCHER_EVENT_NAME_22:"WS 75% sensor",
      KARCHER_EVENT_NAME_23:"Tech. defect",
      KARCHER_EVENT_NAME_24:"Oper. defect",
      KARCHER_EVENT_NAME_25:"Unit on",
      KARCHER_EVENT_NAME_26:"Unit closed",
      KARCHER_EVENT_NAME_27:"Box 1 closed",
      KARCHER_EVENT_NAME_28:"Box 2 closed",
      KARCHER_EVENT_NAME_29:"Box 3 closed",
      KARCHER_EVENT_NAME_30:"Box 4 closed",
      KARCHER_EVENT_NAME_31:"Box 5 closed",
      KARCHER_EVENT_NAME_32:"Box 6 closed",
      KARCHER_EVENT_NAME_33:"Box 7 closed",
      KARCHER_EVENT_NAME_34:"Box 8 closed",
      KARCHER_EVENT_NAME_35:"HP pump bay 1",
      KARCHER_EVENT_NAME_36:"HP pump bay 2",
      KARCHER_EVENT_NAME_37:"HP pump bay 3",
      KARCHER_EVENT_NAME_38:"HP pump bay 4",
      KARCHER_EVENT_NAME_39:"HP pump bay 5",
      KARCHER_EVENT_NAME_40:"HP pump bay 6",
      KARCHER_EVENT_NAME_41:"HP pump bay 7",
      KARCHER_EVENT_NAME_42:"HP pump bay 8",
      KARCHER_EVENT_NAME_43:"Burner",
      KARCHER_EVENT_NAME_44:"Burner fan",
      KARCHER_EVENT_NAME_45:"Warm water pump",
      KARCHER_EVENT_NAME_46:"Freeze prot.pump",
      KARCHER_EVENT_NAME_47:"Osmosis pump",
      KARCHER_EVENT_NAME_48:"Floor heating",
      KARCHER_EVENT_NAME_49:"Hose heating",
      KARCHER_EVENT_NAME_50:"Microe/rim clean",
      KARCHER_EVENT_NAME_51:"Underc. pump",
      KARCHER_EVENT_NAME_52:"Booster pumpFoam",
      KARCHER_EVENT_NAME_53:"Vacuum clean. 1",
      KARCHER_EVENT_NAME_54:"Vacuum clean. 2",
      KARCHER_EVENT_NAME_55:"Vacuum clean. 3",
      KARCHER_EVENT_NAME_56:"Vacuum clean. 4",
      KARCHER_EVENT_NAME_57:"Vacuum clean. 5",
      KARCHER_EVENT_NAME_58:"Vacuum clean. 6",
      KARCHER_EVENT_NAME_59:"Vacuum clean. 7",
      KARCHER_EVENT_NAME_60:"Vacuum clean. 8",
      KARCHER_EVENT_NAME_61:"Vacuum clean. 9",
      KARCHER_EVENT_NAME_62:"Vacuum clean. 10",
      KARCHER_EVENT_NAME_63:"Vacuum clean. 11",
      KARCHER_EVENT_NAME_64:"Vacuum clean. 12",
      KARCHER_EVENT_NAME_65:"Pump rim clean",
      KARCHER_EVENT_NAME_66:"Pump Microe.",
      KARCHER_EVENT_NAME_67:"Pump Intensive",
      KARCHER_EVENT_NAME_68:"Vacuum1 turbine",
      KARCHER_EVENT_NAME_69:"Vacuum1 filter",
      KARCHER_EVENT_NAME_70:"Vacuum2 turbine",
      KARCHER_EVENT_NAME_71:"Vacuum2 filter",
      KARCHER_EVENT_NAME_72:"Vacuum3 turbine",
      KARCHER_EVENT_NAME_73:"Vacuum3 filter",
      KARCHER_EVENT_NAME_74:"Vacuum4 turbine",
      KARCHER_EVENT_NAME_75:"Vacuum4 filter",
      KARCHER_EVENT_NAME_76:"Vacuum5 turbine",
      KARCHER_EVENT_NAME_77:"Vacuum5 filter",
      KARCHER_EVENT_NAME_78:"Vacuum6 turbine",
      KARCHER_EVENT_NAME_79:"Vacuum6 filter",
      KARCHER_EVENT_NAME_80:"Vacuum7 turbine",
      KARCHER_EVENT_NAME_81:"Vacuum7 filter",
      KARCHER_EVENT_NAME_82:"Vacuum8 turbine",
      KARCHER_EVENT_NAME_83:"Vacuum8 filter",
      KARCHER_EVENT_NAME_84:"Vacuum9 turbine",
      KARCHER_EVENT_NAME_85:"Vacuum9 filter",
      KARCHER_EVENT_NAME_86:"Vacuum10 turbine",
      KARCHER_EVENT_NAME_87:"Vacuum10 filter",
      KARCHER_EVENT_NAME_88:"Vacuum11 turbine",
      KARCHER_EVENT_NAME_89:"Vacuum11 filter",
      KARCHER_EVENT_NAME_90:"Vacuum12 turbine",
      KARCHER_EVENT_NAME_91:"Vacuum12 filter",
      INSERT_TOKEN:"Вставьте токены и запустите услугу",
      OPEN_SESSION:"Сеанс успешно открыт",
      IN_PROGRESS:"Выполняется ...",
      TOKEN_INSERTED:"Токены успешно вставлены",
      EXPIRED_SESSION:"Срок действия сеанса истёк",
      TWO_DIGIT_INTEGER_VALIDATION:"Use max two digit integer",
      KARCHER_OPERATION_COUNTER_1:"Washing station 1 HP pump",
      KARCHER_OPERATION_COUNTER_2:"Washing station 1 chemical pump 1",
      KARCHER_OPERATION_COUNTER_3:"Washing station 1 chemical pump 2",
      KARCHER_OPERATION_COUNTER_4:"Washing station 1 chemical pump 3",
      KARCHER_OPERATION_COUNTER_5:"Washing station 1 chemical pump 4",
      KARCHER_OPERATION_COUNTER_6:"Washing station 2 HP pump",
      KARCHER_OPERATION_COUNTER_7:"Washing station 2 chemical pump 1",
      KARCHER_OPERATION_COUNTER_8:"Washing station 2 chemical pump 2",
      KARCHER_OPERATION_COUNTER_9:"Washing station 2 chemical pump 3",
      KARCHER_OPERATION_COUNTER_10:"Washing station 2 chemical pump 4",
      KARCHER_OPERATION_COUNTER_11:"Washing station 3 HP pump",
      KARCHER_OPERATION_COUNTER_12:"Washing station 3 chemical pump 1",
      KARCHER_OPERATION_COUNTER_13:"Washing station 3 chemical pump 2",
      KARCHER_OPERATION_COUNTER_14:"Washing station 3 chemical pump 3",
      KARCHER_OPERATION_COUNTER_15:"Washing station 3 chemical pump 4",
      KARCHER_OPERATION_COUNTER_16:"Washing station 4 HP pump",
      KARCHER_OPERATION_COUNTER_17:"Washing station 4 chemical pump 1",
      KARCHER_OPERATION_COUNTER_18:"Washing station 4 chemical pump 2",
      KARCHER_OPERATION_COUNTER_19:"Washing station 4 chemical pump 3",
      KARCHER_OPERATION_COUNTER_20:"Washing station 4 chemical pump 4",
      KARCHER_OPERATION_COUNTER_21:"Washing station 5 HP pump",
      KARCHER_OPERATION_COUNTER_22:"Washing station 5 chemical pump 1",
      KARCHER_OPERATION_COUNTER_23:"Washing station 5 chemical pump 2",
      KARCHER_OPERATION_COUNTER_24:"Washing station 5 chemical pump 3",
      KARCHER_OPERATION_COUNTER_25:"Washing station 5 chemical pump 4",
      KARCHER_OPERATION_COUNTER_26:"Washing station 6 HP pump",
      KARCHER_OPERATION_COUNTER_27:"Washing station 6 chemical pump 1",
      KARCHER_OPERATION_COUNTER_28:"Washing station 6 chemical pump 2",
      KARCHER_OPERATION_COUNTER_29:"Washing station 6 chemical pump 3",
      KARCHER_OPERATION_COUNTER_30:"Washing station 6 chemical pump 4",
      KARCHER_OPERATION_COUNTER_31:"Washing station 7 HP pump",
      KARCHER_OPERATION_COUNTER_32:"Washing station 7 chemical pump 1",
      KARCHER_OPERATION_COUNTER_33:"Washing station 7 chemical pump 2",
      KARCHER_OPERATION_COUNTER_34:"Washing station 7 chemical pump 3",
      KARCHER_OPERATION_COUNTER_35:"Washing station 7 chemical pump 4",
      KARCHER_OPERATION_COUNTER_36:"Washing station 8 HP pump",
      KARCHER_OPERATION_COUNTER_37:"Washing station 8 chemical pump 1",
      KARCHER_OPERATION_COUNTER_38:"Washing station 8 chemical pump 2",
      KARCHER_OPERATION_COUNTER_39:"Washing station 8 chemical pump 3",
      KARCHER_OPERATION_COUNTER_40:"Washing station 8 chemical pump 4",
      KARCHER_OPERATION_COUNTER_41:"Osmosis pump",
      KARCHER_OPERATION_COUNTER_42:"Hot water generator",
      KARCHER_OPERATION_COUNTER_43:"Frost protection pump",
      KARCHER_OPERATION_COUNTER_44:"WSO filter inlay",
      KARCHER_OPERATION_COUNTER_45:"Washing station heater pump",
      KARCHER_OPERATION_COUNTER_46:"Hot water pump",
      KARCHER_OPERATION_COUNTER_47:"Foam hose heating",
      KARCHER_OPERATION_COUNTER_48:"Wheel cleaning pump",
      KARCHER_OPERATION_COUNTER_49:"Micro-emulsion pump",
      KARCHER_OPERATION_COUNTER_50:"Intensive foam pump",
      KARCHER_OPERATION_COUNTER_51:"Vacuum cleaner 1 turbine 1",
      KARCHER_OPERATION_COUNTER_52:"Vacuum cleaner 1 filter 1",
      KARCHER_OPERATION_COUNTER_53:"Vacuum cleaner 1 turbine 2",
      KARCHER_OPERATION_COUNTER_54:"Vacuum cleaner 1 filter 2",
      KARCHER_OPERATION_COUNTER_55:"Vacuum cleaner 2 turbine 1",
      KARCHER_OPERATION_COUNTER_56:"Vacuum cleaner 2 filter 1",
      KARCHER_OPERATION_COUNTER_57:"Vacuum cleaner 2 turbine 2",
      KARCHER_OPERATION_COUNTER_58:"Vacuum cleaner 2 filter 2",
      KARCHER_OPERATION_COUNTER_59:"Vacuum cleaner 3 turbine 1",
      KARCHER_OPERATION_COUNTER_60:"Vacuum cleaner 3 filter 1",
      KARCHER_OPERATION_COUNTER_61:"Vacuum cleaner 3 turbine 2",
      KARCHER_OPERATION_COUNTER_62:"Vacuum cleaner 3 filter 2",
      KARCHER_OPERATION_COUNTER_63:"Vacuum cleaner 4 turbine 1",
      KARCHER_OPERATION_COUNTER_64:"Vacuum cleaner 4 filter 1",
      KARCHER_OPERATION_COUNTER_65:"Vacuum cleaner 4 turbine 2",
      KARCHER_OPERATION_COUNTER_66:"Vacuum cleaner 4 filter 2",
      KARCHER_OPERATION_COUNTER_67:"Vacuum cleaner 5 turbine 1",
      KARCHER_OPERATION_COUNTER_68:"Vacuum cleaner 5 filter 1",
      KARCHER_OPERATION_COUNTER_69:"Vacuum cleaner 5 turbine 2",
      KARCHER_OPERATION_COUNTER_70:"Vacuum cleaner 5 filter 2",
      KARCHER_OPERATION_COUNTER_71:"Vacuum cleaner 6 turbine 1",
      KARCHER_OPERATION_COUNTER_72:"Vacuum cleaner 6 filter 1",
      KARCHER_OPERATION_COUNTER_73:"Vacuum cleaner 6 turbine 2",
      KARCHER_OPERATION_COUNTER_74:"Vacuum cleaner 6 filter 2",
      KARCHER_OPERATION_COUNTER_75:"Drain condensation water from the compressor",
      KARCHER_OPERATION_COUNTER_76:"Check frost protection system",
      KARCHER_OPERATION_COUNTER_77:"Burner fan",
      KARCHER_OPERATION_COUNTER_78:"Booster pump foam",
      DOWNLOAD_CSV_LARGE_DATA_WARNING:"Список данных содержит более 10000 элементов.",
      KARCHER_POINT_NAME_1:"Holiday",
      KARCHER_POINT_NAME_2:"Monday",
      KARCHER_POINT_NAME_3:"Tuesday",
      KARCHER_POINT_NAME_4:"Wednesday",
      KARCHER_POINT_NAME_5:"Thursday",
      KARCHER_POINT_NAME_6:"Friday",
      KARCHER_POINT_NAME_7:"Saturday",
      KARCHER_POINT_NAME_8:"Sunday",
      KARCHER_POINT_NAME_9:"Vacuums Holiday",
      KARCHER_POINT_NAME_10:"Vacuums Monday",
      KARCHER_POINT_NAME_11:"Vacuums Tuesday",
      KARCHER_POINT_NAME_12:"Vacuums Wednesday",
      KARCHER_POINT_NAME_13:"Vacuums Thursday",
      KARCHER_POINT_NAME_14:"Vacuums Friday",
      KARCHER_POINT_NAME_15:"Vacuums Saturday",
      KARCHER_POINT_NAME_16:"Vacuums Sunday",
      KARCHER_POINT_NAME_17:"Illumination Holiday",
      KARCHER_POINT_NAME_18:"Illumination Monday",
      KARCHER_POINT_NAME_19:"Illumination Tuesday",
      KARCHER_POINT_NAME_20:"Illumination Wednesday",
      KARCHER_POINT_NAME_21:"Illumination Thursday",
      KARCHER_POINT_NAME_22:"Illumination Friday",
      KARCHER_POINT_NAME_23:"Illumination Saturday",
      KARCHER_POINT_NAME_24:"Illumination Sunday",
      KARCHER_POINT_NAME_25:"Program 0",
      KARCHER_POINT_NAME_26:"Program 1",
      KARCHER_POINT_NAME_27:"Program 2",
      KARCHER_POINT_NAME_28:"Program 3",
      KARCHER_POINT_NAME_29:"Program 4",
      KARCHER_POINT_NAME_30:"Program 5",
      KARCHER_POINT_NAME_31:"Program 6",
      KARCHER_POINT_NAME_32:"Program 7",
      KARCHER_POINT_NAME_33:"Program 8",
      KARCHER_POINT_NAME_34:"Program 9",
      KARCHER_POINT_NAME_35:"Program 10",
      KARCHER_POINT_NAME_36:"Program 11",
      KARCHER_POINT_NAME_37:"Program 12",
      KARCHER_POINT_NAME_38:"Program 13",
      KARCHER_POINT_NAME_39:"Program 14",
      KARCHER_POINT_NAME_40:"Program 15",
      KARCHER_POINT_NAME_41:"Program 16",
      KARCHER_POINT_NAME_42:"Program 17",
      KARCHER_POINT_NAME_43:"Program 18",
      KARCHER_POINT_NAME_44:"Program 19",
      KARCHER_POINT_NAME_45:"Program 20",
      KARCHER_POINT_NAME_46:"Program 21",
      KARCHER_POINT_NAME_47:"Program 22",
      KARCHER_POINT_NAME_48:"Program 23",
      KARCHER_POINT_NAME_49:"Program 24",
      KARCHER_POINT_NAME_50:"Program 25",
      KARCHER_POINT_NAME_51:"Program 26",
      KARCHER_POINT_NAME_52:"Program 27",
      KARCHER_POINT_NAME_53:"Program 28",
      KARCHER_POINT_NAME_54:"Program 29",
      KARCHER_POINT_NAME_55:"Program 30",
      KARCHER_POINT_NAME_56: "Program 31",
      KARCHER_POINT_NAME_57: "Program 32",
      QR_CODE: "QR-код",
      ACCEPT_TERMS_AND_CONDITIONS: "Принять условия использования",
      CREATE_AND_PRINT_VOUCHERS: "Создать и напечатать ваучеры",
      CODE_PREFIX_QUESTION: "Префикс кода не введен",
      CODE_PREFIX_QUESTION_TEXT: "Хотите продолжить без префикса кода?",
    ISSUED_DATE: "Дата выдачи",
    VOUCHER_VALIDITY_DAYS: "Срок действия купона (дни)",
    VALIDATION_ONLY_NUMBERS: "Разрешены только цифры",
    REPRINT_VOUCHERS: "Напечатать копию купонов",
    EXPIRY_DATE: "Действителен до",
    VOUCHER_TYPE_VACUUM: "Ваучер на: Пылесос",
    VOUCHER_TYPE_JETWASH: "Ваучер на: Jet Wash Care",
    VOUCHER_TYPE_MATT: "Ваучер на: Matt"
  });
})();
